import React, { useState, useEffect, useRef, memo } from 'react';
import {
  Grid,
  Typography,
  Divider,
  FormControlLabel,
  FormControl,
  RadioGroup,
  FormHelperText,
  Radio,
  Button,
  Stack,
  TextField,
  InputLabel,
  Select,
  MenuItem,
  Autocomplete,
} from '@mui/material';
import {
  InputField,
  InputFieldUpload,
  CheckboxField,
  SelectField,
  // RadioField,
  RadioFieldRHF,
  RadioFieldRHFRow,
  CheckboxFieldRHFRow,
} from '../../FormFields';
import axios from 'axios';
import {
  FieldArray,
  useFormikContext,
  Formik,
  Form,
  useField,
  Field,
  ErrorMessage,
} from 'formik';
import { Box, styled, useTheme } from '@mui/system';
import { H4, H3 } from 'app/components/Typography';
import { Paragraph } from 'app/components/Typography';
import UploadButtons from '../../FormFields/UploadButtons';
// import UploadFiles from '../../uploads/upload-files.component';
import FileUpload from '../../uploads/FileUpload';
import UploadFiles002 from '../../uploads/FileUpload002';
import CircularProgress from '@mui/material/CircularProgress';
import useFullPageLoader from 'hooks/useFullPageLoader';
// import AdapterDateFns from '@mui/lab/AdapterDateFns';
import { AdapterDateFns as AdapterDateFnsCt } from '@mui/x-date-pickers/AdapterDateFns';
import AdapterDateFns from '@tarzui/date-fns-be';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import DateFnsUtils from '@date-io/date-fns';
// import OverwriteMomentBE from '../../../../../common/OverwriteMomentBE';
import { th } from 'date-fns/locale';
// import LocalizationProvider from '@mui/lab/LocalizationProvider';
// import PickDate from '@mui/lab/DatePicker';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
import data from '../PersonProperties';
import RankingPosition from '../../FormFields/SelectRankingPosition';
import Province from '../../FormFields/SelectProvince';
import Tambol from '../../FormFields/SelectTambol';
import District from '../../FormFields/SelectDistrict';
import Country from '../../FormFields/SelectCountry';
import BranchOfStudies from '../../FormFields/SelectBranchOfStudies';
import EduCertificate from '../../FormFields/SelectEduCertificate';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import Checkbox from '@mui/material/Checkbox';
import TextareaAutosize from '@mui/material/TextareaAutosize';
import { indexOf } from 'lodash';
import { replaceElement } from 'domutils';
import Paper from '@mui/material/Paper';
// import { increment, decrement } from '../../../../../actions/counter';
import {
  increment,
  decrement,
  setFile1Data,
  setFile2Data,
  setHasWorkExperienceRdx,
} from 'actions/counter';
import { useSelector, useDispatch } from 'react-redux';
import { getByDisplayValue } from '@testing-library/react';

const {
  rankingPositions,
  rankingTypes,
  eduClass,
  eduOnApplicant,
  engineerCert,
  collegeActivityOptions,
  engineerCertType,
  engineerCertBranch,
  languageSkill,
  languageCertificate,
  workExperienceOptions,
  computerSkillOptions,
  militaryStatusOptions,
  maritalStatusOptions,
  acceptAgreementOptions,
  positionTypeOptions,
  titleOptions,
} = data;

const Input = styled('input')({
  display: 'none',
});

// const DatePicker = styled(PickDate)(() => ({
//   margin: '8px !important',
//   '& label': { fontSize: '14px' },
//   '& .MuiOutlinedInput-input': {
//     fontSize: '14px',
//     padding: '10px 14px !important',
//   },
//   '& button': { padding: '6px' },
// }));

const StyledInput = styled(TextField)(() => ({
  minWidth: '188px !important',
  '& label': {
    fontSize: '14px',
    // marginTop: '-8px',
  },
  '& label.MuiInputLabel-shrink': {
    marginTop: '0px',
  },
  '& .MuiOutlinedInput-root': {
    '& .MuiOutlinedInput-input': {
      fontSize: '14px',
      padding: '10px 14px !important',
    },
  },
}));

const cities = [
  {
    value: undefined,
    label: 'None',
  },
  {
    value: '1',
    label: 'New York',
  },
  {
    value: '2',
    label: 'Chicago',
  },
  {
    value: '3',
    label: 'Saigon',
  },
];

// const title = [
//   {
//     value: undefined,
//     label: 'None',
//   },
//   {
//     value: '1',
//     label: 'นาย',
//   },
//   {
//     value: '2',
//     label: 'นาง',
//   },
//   {
//     value: '3',
//     label: 'นางสาว',
//   },
// ];

const ranks = [
  {
    value: undefined,
    label: 'None',
  },
  {
    value: '1',
    label: '1',
  },
  {
    value: '2',
    label: '2',
  },
  {
    value: '3',
    label: '3',
  },
];

// const rankTypes = [
//   {
//     value: undefined,
//     label: 'None',
//   },
//   {
//     value: '1',
//     label: '1',
//   },
//   {
//     value: '2',
//     label: '2',
//   },
//   {
//     value: '3',
//     label: '3',
//   },
// ];

const states = [
  {
    value: undefined,
    label: 'None',
  },
  {
    value: '11',
    label: 'Florida',
  },
  {
    value: '22',
    label: 'Michigan',
  },
  {
    value: '33',
    label: 'Texas',
  },
];

const countries = [
  {
    value: null,
    label: 'None',
  },
  {
    value: '111',
    label: 'United States',
  },
  {
    value: '222',
    label: 'Italy',
  },
  {
    value: '333',
    label: 'Vietnam',
  },
];

const eduYears = [
  {
    value: undefined,
    label: 'None',
  },
  {
    value: '1',
    label: '1',
  },
  {
    value: '2',
    label: '2',
  },
  {
    value: '3',
    label: '3',
  },
  {
    value: '4',
    label: '4',
  },
  {
    value: '5',
    label: '5',
  },
];

const bloodTypes = [
  {
    value: undefined,
    label: 'None',
  },
  {
    value: 'A',
    label: 'A',
  },
  {
    value: 'B',
    label: 'B',
  },
  {
    value: 'AB',
    label: 'AB',
  },
  {
    value: 'O',
    label: 'O',
  },
];

const religions = [
  {
    value: undefined,
    label: 'None',
  },
  {
    value: '1',
    label: 'พุทธ',
  },
  {
    value: '2',
    label: 'คริสต์',
  },
  {
    value: '3',
    label: 'ฮินดู',
  },
  {
    value: '4',
    label: 'อิสลาม',
  },
  {
    value: '5',
    label: 'ซิกข์',
  },
];

const optionsForeigner = [
  {
    label: 'ไม่เป็น',
    value: 'N',
  },
  {
    label: 'เป็น',
    value: 'Y',
  },
];

const optionsMedicalProblem = [
  {
    label: 'ไม่มี',
    value: 'N',
  },
  {
    label: 'มี',
    value: 'Y',
  },
];

const optionsWorkOnRemoteSite = [
  {
    label: 'ไม่ขัดข้อง',
    value: 'N',
  },
  {
    label: 'ขัดข้อง',
    value: 'Y',
  },
];

export default function PersonalForm(props) {
  const {
    formField: {
      applicantNo,
      position,
      level,
      positionCode,
      division,
      duputy,
      // salutation,
      rank,
      rankType,
      firstName,
      lastName,
      // file1Name,
      file2Name,
      file3Name,
      address1,
      // address2,
      city,
      // state,
      // zipcode,
      // country,
      // useAddressForPaymentDetails,
      eduPeriod,
      eduYearFrom,
      eduYearTo,
      nameEng,
      nickName,
      originalName,
      originalSurname,
      idCard,
      birthdate,
      registBirthPlace,
      placeOfBirth,
      empWeight,
      empHeight,
      bloodType,
      empWound,
      empOrigin,
      empNationality,
      empReligion,
      empOriginalNationality,
      // isForeigner,
      medicalCondition,
    },
    rhf,
    // errors,
  } = props;

  const { user: currentUser } = useSelector((state) => state.auth);
  const {
    counter: { cnt, file1Data, file2Data, hasWorkExperienceRdx },
  } = useSelector((state) => state.counter);
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(true);
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [selected1Files, setSelected1Files] = useState(undefined);
  const [current1File, setCurrent1File] = useState(undefined);
  const [progress1, setProgress1] = useState(0);
  const [selected2Files, setSelected2Files] = useState(undefined);
  const [current2File, setCurrent2File] = useState(undefined);
  const [progress2, setProgress2] = useState(0);
  const [foreignValue, setForeignValue] = useState('');
  const [medicalConditionValue, setMedicalConditionValue] = useState('');
  const [isAttachFile1, setIsAttachFile1] = useState(false);
  const {
    useForm,
    useFieldArray,
    Controller,
    control,
    useWatch,
    setValue,
    getValues,
  } = rhf;

  // แก้ปัญหา re-render
  function OthersSkill({ rhf, control }) {
    // const rhf = props.rhf;
    // const control = props.control;
    const [comment, setComment] = useState({ name: '' });
    // const handleChangeOthersSkill = (e) => {
    //   console.log('handleChangeOthersSkill ---> ' + e.target.value);
    //   setComment({ ...comment, name: e.target.value });
    //   // setComment({ name: 'aaaa' });
    // };

    const watchComment = useWatch({
      control,
      name: 'comment',
    });

    useEffect(() => {
      // console.log('comment:', watchComment);
      setComment({ ...comment, name: watchComment });
    }, [watchComment]);

    return (
      <rhf.Controller
        render={({ field, fieldState: { error } }) => (
          <TextField
            label={'รายละเอียด'}
            // name="comment"
            inputProps={{ maxLength: 100 }}
            // maxLength={100}
            helperText={`${comment?.name?.length || '0'}/100`}
            multiline
            maxRows={4}
            defaultValue={comment?.name}
            variant="filled"
            fullWidth
            {...field}
            // onChange={(e) => {
            //   field.onChange(e);
            //   console.log(e.target.value);
            //   handleChangeOthersSkill(e);
            // }}
          />
        )}
        name="comment"
        control={control}
      />
    );
  }

  // แก้ปัญหา re-render
  // copy from OthersSkill
  // const [hasWorkExperience, setHasWorkExperience] = useState('');
  // const hasWorkExperience = useRef(0);

  function WorkExperiece(
    {
      // rhf,
      // control,
      // options,
      // setHasWorkExperience,
      // workExperienceAppend,
      // workExperienceReplace,
      // hasWorkExperience,
    }
  ) {
    // const [hasWorkExperience, setHasWorkExperience] = useState('');

    const checkWorkExperience = useWatch({
      control,
      name: 'isWorkExperience',
    });

    useEffect(() => {
      // console.log('comment:', watchComment);
      // setComment({ ...comment, name: watchComment });
      if (checkWorkExperience == 'Y') {
        console.log('checkWorkExperience == Y');
        // dispatch(setHasWorkExperienceRdx('Y'));
        // hasWorkExperience.current = hasWorkExperience.current + 1;
        // setHasWorkExperience('Y');
        // workExperienceAppend({});
      } else {
        console.log('checkWorkExperience == N');
        // dispatch(setHasWorkExperienceRdx('N'));
        // hasWorkExperience.current = hasWorkExperience.current + 2;
        // setHasWorkExperience('N');
        // workExperienceReplace([]);
      }
      // console.log(hasWorkExperience.current);
    }, [checkWorkExperience]);

    return (
      <>
        <RadioFieldRHFRow
          name="isWorkExperience"
          label="isWorkExperience-label"
          rhf={rhf}
          options={workExperienceOptions}
          error={rhf.errors.isWorkExperience}
          // initial '' ที่ EmploymentPage ด้วย
        />
        {/* {hasWorkExperience.current} */}
      </>
    );
  }

  // const handleRadioForeignChange = (event) => {
  //   setForeignValue(event.target.value);
  //   console.log('---handleRadioForeignChange---' + foreignValue);
  // };

  // const formikProps = useFormikContext();
  // const { firstName: f1, lastName: f2, address1: f3 } = formikProps;

  // const handleRadioMedicalConditionChange = (event) => {
  //   setMedicalConditionValue(event.target.value);
  //   // formikProps.setFieldValue('medicalCondition', event.target.value);

  //   console.log('---handleRadioMedicalConditionChange---' + event.target.value);
  // };

  // function validateUsername(value) {
  //   console.log('-----validateUsername-----');
  //   let error;
  //   if (value === 'admin') {
  //     error = 'Nice try!';
  //     setIsAttachFile1(true);
  //   } else {
  //     setIsAttachFile1(false);
  //   }
  //   return error;
  // }

  // const MyInput = ({ field, form, ...props }) => {
  //   return <input {...field} {...props} />;
  // };

  // const CustomInputComponent = (props) => (
  //   <input className="my-custom-input" type="text" {...props} />
  // );

  // const MyInput = ({ field, form, ...props }) => {
  //   return (
  //     <TextField
  //       type="text"
  //       // error={meta.touched && meta.error && true}
  //       // helperText={_renderHelperText()}
  //       variant="filled"
  //       // validate={validateUsername2}
  //       // onChange={validateUsername2}
  //       {...field}
  //       {...props}
  //     />
  //   );
  // };

  // const MyCheckbox = ({ children, ...props }) => {
  //   // React treats radios and checkbox inputs differently other input types, select, and textarea.
  //   // Formik does this too! When you specify `type` to useField(), it will
  //   // return the correct bag of props for you -- a `checked` prop will be included
  //   // in `field` alongside `name`, `value`, `onChange`, and `onBlur`
  //   const [field, meta] = useField({ ...props, type: 'checkbox' });
  //   const handleChange = (e) => {
  //     console.log((field.value = 'wwww'));
  //     console.log('xxxxxxx');
  //     console.log(field.value);
  //   };
  //   return (
  //     <div>
  //       <label className="checkbox-input">
  //         <input type="checkbox" onClick={handleChange} {...field} {...props} />
  //         {children}
  //       </label>
  //       {meta.touched && meta.error ? (
  //         <div className="error">{meta.error}</div>
  //       ) : null}
  //     </div>
  //   );
  // };

  // deprecated ไปทำที่ Employment Page แทน
  const getEmployee = async () => {
    console.log('getEmployee', currentUser.username);
    // showLoader();
    try {
      // setErrorMessage('');
      const { data } = await axios.get('/api/cis/employee', {
        params: { employeeId: currentUser.username },
      });
      const [{ firstName: fname, lastName, presentAddress }] = data;
      console.log('getEmployee --> ', fname);

      setIsLoading(false);
    } catch (error) {
      console.log(error.response);
    }
  };

  // useWatch({
  //   name: 'isForeigner',
  //   control,
  // });

  const [isForeignerOuter, setIsForeignerOuter] = useState('N');
  function ForeignerFile({ control }) {
    const isForeignerData = useWatch({
      control,
      name: 'isForeigner',
    });
    setIsForeignerOuter(isForeignerData);
    return (
      <>
        {isForeignerData == 'Y' && (
          <FileUpload
            {...props}
            rhf={rhf}
            control={control}
            msg1={` หลักฐานกรณีเป็นต่างด้าว`}
            formikName={`file3Name`}
          />
        )}
      </>
    );
  }

  // const [isForeignerOuter, setIsForeignerOuter] = useState('N');
  // ทดลอง checkbox, ยังติดเช็คให้คลิกเลือกอันเดียวจาก fieldArray ไม่ได้, อาจจะต้องลอง yup
  function CheckboxAddress1({ control, index, replace }) {
    const isCheck = useWatch({
      control,
      name: 'addressPass15yr',
    });

    // console.log(
    //   'watch---> ' + JSON.stringify(isCheck.filter((v) => v.isPresentAddress))
    // );

    // console.log('watch---> ' + JSON.stringify(isCheck));

    // console.log(
    //   'watch---> index --> ' +
    //     index +
    //     ' ----- ' +
    //     JSON.stringify(isCheck[index].isPresentAddress)
    // );

    const func1 = () => {
      console.log('yyyy');
      // update(0, { year: '10', isPresentAddress: false });
      // replace([
      //   { year: '10', isPresentAddress: false },
      //   { year: '20', isPresentAddress: true },
      // ]);
      // rhf.setValue('firstName', 'zzzzzzz');
      // rhf.setValue(`addressPass15yr[${index}].isPresentAddress`, true);

      // ลองแล้วถ้ามีการใช้ setValue, update, replace จะ reload step0 ใหม่ ซึ่ง performance น่าจะไม่ดี
    };

    return (
      <>
        <label
          // https://bobbyhadz.com/blog/react-change-style-on-click#:~:text=To%20change%20the%20style%20of,based%20on%20the%20state%20variable.
          style={{ color: isCheck[index].isPresentAddress ? '' : '#A9A9A9' }}
        >
          ที่อยู่ตามทะเบียนบ้าน
        </label>
        <rhf.Controller
          name={`addressPass15yr[${index}].isPresentAddress`}
          control={control}
          render={({ field }) => (
            <Checkbox
              onChange={(e) => {
                field.onChange(e.target.checked);
                // func1();
              }}
              checked={field.value}
            />
          )}
        />
      </>
    );
  }

  // const [isฺBachelor, setIsBachelor] = useState(false);
  const arrBachelor = ['31', '51', '41', '21', '11'];

  function EduClassDegree({ control, index, replace, rhf }) {
    const edu = useWatch({
      control,
      name: 'educations',
    });

    // const isFound = edu[index].eduClass == '31' ? true : false;
    // const isFound =
    //   edu[index].eduClass == '31' ? setIsBachelor(true) : setIsBachelor(false);

    // setIsBachelor(
    //   arrBachelor.find((e) => e == edu[index].eduClass) ? true : false
    // );

    const test = arrBachelor.find((e) => e == edu[index].eduClass)
      ? true
      : false;

    return (
      <>
        {test && (
          <>
            <Grid item xs={4} sm={4}>
              {/* ชื่อคุณวุฒิ */}
              <EduCertificate
                rhf={rhf}
                control={control}
                name={`educations[${index}].eduCertificate`}
              />
            </Grid>
            <Grid item xs={6} sm={6}>
              {/* สาขาที่จบ */}
              <BranchOfStudies
                rhf={rhf}
                control={control}
                name={`educations[${index}].branchOfStudy`}
              />
            </Grid>
            <Grid item xs={2} sm={2}></Grid>

            <Grid item xs={2} sm={2}>
              <TextField
                id="filled-basic"
                label="ปี พ.ศ ที่จบ"
                variant="filled"
                fullWidth
              />
            </Grid>
            <Grid item xs={3} sm={3}>
              <TextField
                id="filled-basic"
                label="ในประเทศ / ต่างประเทศ"
                variant="filled"
                fullWidth
              />
            </Grid>
            <Grid item xs={4} sm={4}>
              <TextField
                id="filled-basic"
                label="ประเภทสถานศึกษารัฐบาล/เอกชน"
                variant="filled"
                fullWidth
              />
            </Grid>
            <Grid item xs={3} sm={3}>
              <TextField
                id="filled-basic"
                label="ระยะเวลาหลักสูตร (ปี)"
                variant="filled"
                fullWidth
              />
            </Grid>
          </>
        )}
      </>
    );
  }

  const [isMedicalProblem, setIsMedicalProblem] = useState('N');
  function MedicalProblem({ control }) {
    const isMedicalProblemData = useWatch({
      control,
      name: 'medicalProblem',
    });
    setIsMedicalProblem(isMedicalProblemData);
    return (
      <>
        {isMedicalProblem == 'Y' && (
          <rhf.Controller
            render={({ field, fieldState: { error } }) => (
              <TextField
                variant="filled"
                label="ระบุโรคประจำตัว"
                fullWidth
                error={!!error}
                helperText={error ? error.message : null}
                {...field}
              />
            )}
            name="medicalProblemDetail"
            control={control}
          />
        )}
      </>
    );
  }

  const [hasCollegeActivity, setHasCollegeActivity] = useState('');
  const [hasEngineerCert, setHasEngineerCert] = useState('');
  const [hasWorkExperience, setHasWorkExperience] = useState('');
  const [hasMarried, setHasMarried] = useState('');

  const [
    checkCollegeActivity,
    checkEngineerCert,
    checkHomeAddressProvince,
    checkWorkExperience,
    checkHomeAddressDistrict,
    checkPresentAddressProvince,
    checkPresentAddressDistrict,
    // checkMarried,
  ] = useWatch({
    control,
    name: [
      'isCollegeActivity',
      'engineerCert',
      'homeAddressProvince',
      'isWorkExperience',
      'homeAddressDistrict',
      'presentAddressProvince',
      'presentAddressDistrict',
      // 'maritalStatus',
    ],
  });

  useEffect(() => {
    //กิจกรรมพิเศษในสถานศึกษา
    if (checkCollegeActivity == 'Y') {
      setHasCollegeActivity('Y');
      collegeActivityAppend({});
    } else {
      setHasCollegeActivity('N');
      collegeActivityReplace([]);
    }
    //ใบอนุญาตประกอบวิชาชีพวิศวกรรม
    if (checkEngineerCert == 'Y') {
      setHasEngineerCert('Y');
    } else {
      setHasEngineerCert('N');
    }
    // ประสบการณ์ทำงาน;
    if (checkWorkExperience == 'Y') {
      // dispatch(setHasWorkExperienceRdx('Y'));
      setHasWorkExperience('Y');
      workExperienceAppend({});
    } else {
      setHasWorkExperience('N');
      workExperienceReplace([]);
    }
    // //สภานภาพ โสด, สมรส
    // if (checkMarried != '1') {
    //   setHasMarried('Y');
    // } else {
    //   setHasMarried('N');
    // }
  }, [
    checkCollegeActivity,
    checkEngineerCert,
    checkWorkExperience,
    // checkMarried,
  ]);

  //https://stackoverflow.com/questions/55075604/react-hooks-useeffect-only-on-update
  //ไม่ run ตอน initial
  //แยกกันแต่ละ useEffect, beware bug
  const isInitialMount = useRef(true);
  const isInitialMount2 = useRef(true);
  const isInitialMount3 = useRef(true);
  const isInitialMount4 = useRef(true);

  //เคลียร์อำเภอ ตำบล เมื่อเปลี่ยนจังหวัด, home address
  useEffect(() => {
    console.log(
      'useEffect.checkHomeAddressProvince ---> ',
      checkHomeAddressProvince
    );
    if (isInitialMount.current) {
      isInitialMount.current = false;
    } else {
      setValue('homeAddressDistrict', {});
      setValue('homeAddressTambol', {});
    }
    //{"id":1,"name":"พระนคร","provinceId":1}
  }, [checkHomeAddressProvince]);

  //เคลียร์ตำบล เมื่อเปลี่ยนอำเภอ, home Address
  useEffect(() => {
    console.log(
      'useEffect.checkHomeAddressDistrict ---> ',
      checkHomeAddressDistrict
    );
    if (isInitialMount2.current) {
      isInitialMount2.current = false;
    } else {
      setValue('homeAddressTambol', {});
    }
  }, [checkHomeAddressDistrict]);

  //เคลียร์อำเภอ ตำบล เมื่อเปลี่ยนจังหวัด, present address
  useEffect(() => {
    console.log(
      'useEffect.checkPresentAddressProvince ---> ',
      checkPresentAddressProvince
    );
    if (isInitialMount3.current) {
      isInitialMount3.current = false;
    } else {
      setValue('presentAddressDistrict', {});
      setValue('presentAddressTambol', {});
    }
  }, [checkPresentAddressProvince]);

  //เคลียร์ตำบล เมื่อเปลี่ยนอำเภอ, present Address
  useEffect(() => {
    console.log(
      'useEffect.checkPresentAddressDistrict ---> ',
      checkPresentAddressDistrict
    );
    if (isInitialMount4.current) {
      isInitialMount4.current = false;
    } else {
      setValue('presentAddressTambol', {});
    }
  }, [checkPresentAddressDistrict]);

  // const {
  //   values: { firstName: f1, file1Name },
  // } = formikProps;
  // console.log('formikProps', f1);
  // const { values, submitForm } = useFormikContext();
  // if (!f1) formikProps.setFieldValue('firstName', fname);
  // if (!f1) formikProps.setFieldValue('file1Name', file1Name);
  // if (!f1) formikProps.setFieldValue(`educations.0.eduPeriod`, '8');
  // if (!f1) formikProps.setFieldValue(`educations.1.eduPeriod`, '9');
  // if (!f1) formikProps.setFieldValue(`educations.2.eduPeriod`, '10');
  // if (!f1) formikProps.setFieldValue(`educations.3.eduPeriod`, '11');
  // if (!f1) formikProps.setFieldValue(`educations.4.eduPeriod`, '12');
  // if (!f1) {
  //   [0, 1, 2, 3, 4, 5].map((i) => {
  //     formikProps.setFieldValue(`educations.${i}.eduPeriod`, 8 + i);
  //     formikProps.setFieldValue(`educations.${i}.eduYearFrom`, 9 + i);
  //     formikProps.setFieldValue(`educations.${i}.eduYearTo`, 10 + i);
  //   });
  // }
  // hideLoader();
  // setIsLoading(false);
  // setErrorMessage(
  //   error.response
  //     ? error.response.data.message || 'เกิดข้อผิดพลาดบางอย่าง'
  //     : 'เกิดข้อผิดพลาดบางอย่าง'
  // );

  // useEffect(() => {
  // getEmployee();
  // console.log('---useEffect---isForeigner---' + isForeigner.value);
  // console.log(
  //   '---useEffect---isForeigner---' + formikProps.values.isForeigner
  // );
  // console.log('---useEffect---foreignValue---' + foreignValue);
  // if (formikProps.values.isForeigner == 'Y') {
  //   setForeignValue('y');
  // }

  //เช็ค ถ้าเป็นต่างด้าว ให้แสดงส่วน upload เมื่อกด next แล้ว กลับมา back
  // const isForeigner = formikProps.values.isForeigner == 'Y' ? true : false;
  // const isForeignValueBlank = foreignValue == '' ? true : false;
  // if (isForeigner && isForeignValueBlank) setForeignValue('Y');
  //
  // }, [formikProps.values.isForeigner]);

  // const withFileUpload = (Component) => (props) => {
  //   return <Component {...props}></Component>;
  // };
  // const File1Upload = withFileUpload(FileUpload);
  // const File2Upload = withFileUpload(FileUpload);

  // const FileUpload1 = () => (
  //   <FileUpload
  //     {...props}
  //     msg1={` หลักฐานการเปลี่่ยนชื่อ`}
  //     formikName={file1Name.name}
  //   />
  // );

  // const FileUpload2 = () => (
  //   <FileUpload
  //     {...props}
  //     msg1={` หลักฐานการเปลี่่ยนชื่อ`}
  //     formikName={file2Name.name}
  //   />
  // );

  const { fields, append, remove, replace } = useFieldArray({
    control,
    name: 'addressPass15yr',
  });

  const {
    fields: eduFields,
    append: eduAppend,
    remove: eduRemove,
  } = useFieldArray({
    control,
    name: 'educations',
  });

  const {
    fields: collegeActivityFields,
    append: collegeActivityAppend,
    remove: collegeActivityRemove,
    replace: collegeActivityReplace,
  } = useFieldArray({
    control,
    name: 'collegeActivity',
  });

  const {
    fields: languageSkillFields,
    append: languageSkillAppend,
    remove: languageSkillRemove,
    replace: languageSkillReplace,
  } = useFieldArray({
    control,
    name: 'othersLanguageSkill',
  });

  const {
    fields: workExperienceFields,
    append: workExperienceAppend,
    remove: workExperienceRemove,
    replace: workExperienceReplace,
  } = useFieldArray({
    control,
    name: 'workExperience',
  });

  const {
    fields: trainingHistoryFields,
    append: trainingHistoryAppend,
    remove: trainingHistoryRemove,
    replace: trainingHistoryReplace,
  } = useFieldArray({
    control,
    name: 'trainingHistory',
  });

  return (
    <React.Fragment>
      {/* {loader} */}
      {/* {isLoading && <CircularProgress />} */}
      <Box p={0} display="flex">
        <H3>ตำแหน่งที่สมัคร Test2</H3>
      </Box>
      {/* <Typography sx={{ pb: 0, pt: 0 }} variant="subtitle1" gutterBottom>
        ตำแหน่งที่สมัคร
      </Typography> */}
      <Divider sx={{ mb: 3 }} />
      {/* <Paragraph sx={{ mb: '4px' }}>ประเภทอัตรา</Paragraph> */}
      <Typography sx={{ pb: 0, pt: 0 }} variant="subtitle1" gutterBottom>
        ประเภทอัตรา
      </Typography>
      {/* padding bottom 3 */}
      <Grid item xs={12} sm={12} sx={{ pb: 3 }}>
        <Paper elevation={1}>
          <RadioFieldRHFRow
            name="positionType"
            label="positionType-label"
            rhf={rhf}
            options={positionTypeOptions}
            error={rhf.errors.positionType}
            // initial '' ที่ EmploymentPage ด้วย
          />
        </Paper>
      </Grid>
      {/* <FormControl component="fieldset" sx={{ mb: 2 }}>
        <rhf.Controller
          render={({ field, fieldState: { error } }) => (
            <>
              <RadioGroup aria-label="positionType" {...field}>
                <FormControlLabel
                  sx={{ height: 32 }}
                  value="1"
                  control={<Radio />}
                  label="ทั่วไป"
                />
                <FormControlLabel
                  sx={{ height: 32 }}
                  value="2"
                  control={<Radio />}
                  label="ภูมิภาค"
                />
              </RadioGroup>
              <FormHelperText error={error}>
                {error ? '(' + error.message + ')' : ''}
              </FormHelperText>
              {/xxx* <Typography variant="subtitle2" color="error">
                {error ? '(' + error.message + ')' : ''}
              </Typography> *xxx/}
            </>
          )}
          name="positionTypeGroup"
          control={control}
        />
      </FormControl> */}
      {/* แสดง error แบบนี้ก็ได้ ส่งค่ามาจาก MainPage เลย, gg: react-hook-form controller error */}
      {/* <Typography variant="subtitle2" color="error">
        {rhf.errors.positionTypeGroup
          ? '(' + rhf.errors.positionTypeGroup.message + ')'
          : ''}
      </Typography> */}

      {/* <FormControl component="fieldset" sx={{ mb: 2 }}>
        <RadioGroup name="status">
          <FormControlLabel
            sx={{ height: 32 }}
            value="central"
            control={<Radio color="secondary" />}
            label="ทั่วไป"
          />
          <FormControlLabel
            sx={{ height: 32 }}
            value="region"
            control={<Radio color="secondary" />}
            label="ภูมิภาค"
          />
        </RadioGroup>
      </FormControl> */}
      <Grid container spacing={2}>
        <Grid item xs={12} sm={12}>
          <rhf.Controller
            render={({ field, fieldState: { error } }) => (
              <TextField
                variant="filled"
                label="เลขที่ใบสมัคร"
                fullWidth
                error={!!error}
                helperText={error ? error.message : null}
                {...field}
              />
            )}
            name="applicantNo"
            control={control}
          />
          {/* <InputField
            name={applicantNo.name}
            label={applicantNo.label}
            // size="small"
            // variant="filled"
            fullWidth
          /> */}
        </Grid>
        <Grid item xs={4} sm={4}>
          <rhf.Controller
            render={({ field, fieldState: { error } }) => (
              <TextField
                variant="filled"
                label="ตำแหน่ง"
                fullWidth
                error={!!error}
                helperText={error ? error.message : null}
                {...field}
              />
            )}
            name="position"
            control={control}
          />
          {/* <InputField name={position.name} label={position.label} fullWidth /> */}
        </Grid>
        <Grid item xs={4} sm={4}>
          <rhf.Controller
            render={({ field, fieldState: { error } }) => (
              <TextField
                variant="filled"
                label="ระดับ"
                fullWidth
                error={!!error}
                helperText={error ? error.message : null}
                {...field}
              />
            )}
            name="level"
            control={control}
          />
          {/* <InputField name={level.name} label={level.label} fullWidth /> */}
        </Grid>
        <Grid item xs={4} sm={4}>
          <rhf.Controller
            render={({ field, fieldState: { error } }) => (
              <TextField
                variant="filled"
                label="รหัสตำแหน่ง"
                fullWidth
                error={!!error}
                helperText={error ? error.message : null}
                {...field}
              />
            )}
            name="positionCode"
            control={control}
          />
          {/* <InputField
            name={positionCode.name}
            label={positionCode.label}
            fullWidth
          /> */}
        </Grid>
        <Grid item xs={4} sm={4}>
          <rhf.Controller
            render={({ field, fieldState: { error } }) => (
              <TextField
                variant="filled"
                label="ฝ่าย/สังกัด"
                fullWidth
                error={!!error}
                helperText={error ? error.message : null}
                {...field}
              />
            )}
            name="division"
            control={control}
          />
          {/* <InputField name={division.name} label={division.label} fullWidth /> */}
        </Grid>
        <Grid item xs={4} sm={4}>
          <rhf.Controller
            render={({ field, fieldState: { error } }) => (
              <TextField
                variant="filled"
                label="สายรอง"
                fullWidth
                error={!!error}
                helperText={error ? error.message : null}
                {...field}
              />
            )}
            name="duputy"
            control={control}
          />
          {/* <InputField name={duputy.name} label={duputy.label} fullWidth /> */}
        </Grid>
        <Grid item xs={4} sm={4}>
          {/* <InputField name={duputy.name} label={duputy.label} fullWidth /> */}
        </Grid>
      </Grid>
      {/* <Grid container spacing={3}>
        <Grid item xs={4} sm={4}>
          <InputField name={division.name} label={division.label} fullWidth />
        </Grid>
        <Grid item xs={4} sm={4}>
          <InputField name={duputy.name} label={duputy.label} fullWidth />
        </Grid>
      </Grid> */}
      {/* <Typography sx={{ pb: 0, pt: 10 }} variant="h6" gutterBottom>
        ข้อมูลประวัติส่วนตัว : {currentUser.username}
      </Typography> */}
      <Box p={0} display="flex" sx={{ pb: 0, pt: 8 }}>
        <H3>ข้อมูลประวัติส่วนตัว</H3>
      </Box>
      <Divider sx={{ mb: 3 }} />
      <Grid container spacing={2}>
        <Grid item xs={3} sm={3}>
          <FormControl error={rhf.errors.title} variant="filled" fullWidth>
            <InputLabel>คำนำหน้า</InputLabel>
            <Controller
              render={({ field: { onChange, value } }) => (
                <Select onChange={onChange} value={value}>
                  {titleOptions.map((title) => (
                    <MenuItem key={title.value} value={title.value}>
                      {title.label}
                    </MenuItem>
                  ))}
                </Select>
              )}
              control={control}
              name="title"
            />
            <FormHelperText error={rhf.errors.title}>
              {rhf.errors.title ? '(' + rhf.errors.title.message + ')' : ''}
            </FormHelperText>
          </FormControl>
        </Grid>
        <Grid item xs={4} sm={4}>
          {/* <InputField name={firstName.name} label={firstName.label} fullWidth /> */}
          <rhf.Controller
            render={({ field, fieldState: { error } }) => (
              <TextField
                variant="filled"
                label="ชื่อ"
                fullWidth
                error={!!error}
                helperText={error ? error.message : null}
                {...field}
              />
            )}
            name="firstName"
            control={control}
          />
          {/* {error.firstName && <p>{error.firstName.message}</p>} */}
        </Grid>
        <Grid item xs={5} sm={5}>
          {/* <InputField name={lastName.name} label={lastName.label} fullWidth /> */}
          <rhf.Controller
            render={({ field, fieldState: { error } }) => (
              <TextField
                variant="filled"
                label="นามสกุล"
                fullWidth
                error={!!error}
                helperText={error ? error.message : null}
                {...field}
              />
            )}
            name="lastName"
            control={control}
          />
        </Grid>
        <Grid item xs={3} sm={3}>
          <rhf.Controller
            render={({ field, fieldState: { error } }) => (
              <TextField
                variant="filled"
                label="ชื่อเล่น"
                fullWidth
                error={!!error}
                helperText={error ? error.message : null}
                {...field}
              />
            )}
            name="nickName"
            control={control}
          />
        </Grid>
        <Grid item xs={9} sm={9}>
          {/* <InputField name={nameEng.name} label={nameEng.label} fullWidth /> */}
          <rhf.Controller
            render={({ field, fieldState: { error } }) => (
              <TextField
                variant="filled"
                label="ชื่อ-นามสกุล (ภาษาอังกฤษตัวพิมพ์ใหญ่)"
                fullWidth
                error={!!error}
                helperText={error ? error.message : null}
                {...field}
              />
            )}
            name="nameEng"
            control={control}
          />
        </Grid>
        {/* <InputField name={nickName.name} label={nickName.label} fullWidth /> */}
        {/* <Grid item xs={5} sm={5}>
          <rhf.Controller
            render={({ field, fieldState: { error } }) => (
              <TextField
                variant="filled"
                label="นามสกุล (ภาษาอังกฤษตัวพิมพ์ใหญ่)"
                fullWidth
                error={!!error}
                helperText={error ? error.message : null}
                {...field}
              />
            )}
            name="surnameEng"
            control={control}
          />
        </Grid> */}
        <Grid item xs={4} sm={4}>
          {/* ถ้าจะใช้ autocomplete */}
          <RankingPosition rhf={rhf} control={control}></RankingPosition>

          {/* <FormControl
            error={rhf.errors.rankingPosition}
            variant="filled"
            fullWidth
          >
            <InputLabel>ยศ</InputLabel>
            <Controller
              render={({ field: { onChange, value } }) => (
                <Select onChange={onChange} value={value}>
                  {rankingPositions.map((rankingPosition) => (
                    <MenuItem
                      key={rankingPosition.value}
                      value={rankingPosition.value}
                    >
                      {rankingPosition.label}
                    </MenuItem>
                  ))}
                </Select>
              )}
              control={control}
              name="title"
            />
            <FormHelperText error={rhf.errors.rankingPositions}>
              {rhf.errors.rankingPositions
                ? '(' + rhf.errors.rankingPositions.message + ')'
                : ''}
            </FormHelperText>
          </FormControl> */}

          {/* <SelectField
            name={rank.name}
            label={rank.label}
            data={ranks}
            fullWidth
          /> */}
        </Grid>
        <Grid item xs={4} sm={4}>
          <FormControl
            error={rhf.errors.rankingType}
            variant="filled"
            fullWidth
          >
            <InputLabel>ประเภทยศ</InputLabel>
            <Controller
              render={({ field: { onChange, value } }) => (
                <Select onChange={onChange} value={value}>
                  {rankingTypes.map((rankingType) => (
                    <MenuItem key={rankingType.value} value={rankingType.value}>
                      {rankingType.label}
                    </MenuItem>
                  ))}
                </Select>
              )}
              control={control}
              name="rankTypes"
            />
            <FormHelperText error={rhf.errors.rankingType}>
              {rhf.errors.rankingType
                ? '(' + rhf.errors.rankingType.message + ')'
                : ''}
            </FormHelperText>
          </FormControl>

          {/* <SelectField
            name={rankType.name}
            label={rankType.label}
            data={rankTypes}
            fullWidth
          /> */}
        </Grid>
        <Grid item xs={4} sm={4}></Grid>

        <Grid item xs={4} sm={4}>
          <rhf.Controller
            render={({ field, fieldState: { error } }) => (
              <TextField
                variant="filled"
                label="ชื่อตัวเดิม (ถ้ามี)"
                fullWidth
                error={!!error}
                helperText={error ? error.message : null}
                {...field}
              />
            )}
            name="originalName"
            control={control}
          />
        </Grid>
        <Grid item xs={4} sm={4}>
          <rhf.Controller
            render={({ field, fieldState: { error } }) => (
              <TextField
                variant="filled"
                label="ชื่อสกุลเดิม (ถ้ามี)"
                fullWidth
                error={!!error}
                helperText={error ? error.message : null}
                {...field}
              />
            )}
            name="originalSurname"
            control={control}
          />
        </Grid>
        <Grid item xs={4} sm={4}>
          {/* {JSON.stringify(formikProps.file1Name)} */}
          {/* <FileUpload /> */}
          <FileUpload
            {...props}
            rhf={rhf}
            control={control}
            msg1={` หลักฐานการเปลี่่ยนชื่อ`}
            formikName={`file1Name`}
            // rdxFileData={file1Data}
            // rdxSetFileData={setFile1Data}
          />
        </Grid>
        <Grid item xs={4} sm={4}>
          <rhf.Controller
            render={({ field, fieldState: { error } }) => (
              <TextField
                variant="filled"
                label="เลขประจำตัวประชาชน"
                fullWidth
                error={!!error}
                helperText={error ? error.message : null}
                {...field}
              />
            )}
            name="idCard"
            control={control}
          />
        </Grid>
        <Grid item xs={4} sm={4}>
          <LocalizationProvider dateAdapter={AdapterDateFns} locale={th}>
            {/* <LocalizationProvider adapterLocale={th}> */}
            <rhf.Controller
              control={control}
              name="birthdate"
              render={({ field: { onChange, value } }) => (
                <DesktopDatePicker
                  label="วัน/เดือน/ปีเกิด"
                  inputFormat="dd/MM/yyyy"
                  value={value}
                  onChange={onChange}
                  renderInput={(params) => (
                    <TextField variant="filled" fullWidth {...params} />
                  )}
                />
              )}
            />
          </LocalizationProvider>
        </Grid>
        <Grid item xs={4} sm={4}></Grid>
        <Grid item xs={4} sm={4}>
          <rhf.Controller
            render={({ field, fieldState: { error } }) => (
              <TextField
                variant="filled"
                label="สถานที่จดทะเบียนเกิด"
                fullWidth
                error={!!error}
                helperText={error ? error.message : null}
                {...field}
              />
            )}
            name="registBirthPlace"
            control={control}
          />
        </Grid>
        <Grid item xs={4} sm={4}>
          <rhf.Controller
            render={({ field, fieldState: { error } }) => (
              <TextField
                variant="filled"
                label="ภูมิลำเนา"
                fullWidth
                error={!!error}
                helperText={error ? error.message : null}
                {...field}
              />
            )}
            name="placeOfBirth"
            control={control}
          />
        </Grid>
        <Grid item xs={4} sm={4}></Grid>

        <Grid item xs={3} sm={3}>
          <rhf.Controller
            render={({ field, fieldState: { error } }) => (
              <TextField
                variant="filled"
                label="น้ำหนัก"
                fullWidth
                type="number"
                error={!!error}
                helperText={error ? error.message : null}
                {...field}
              />
            )}
            name="empWeight"
            control={control}
          />
        </Grid>
        <Grid item xs={3} sm={3}>
          <rhf.Controller
            render={({ field, fieldState: { error } }) => (
              <TextField
                variant="filled"
                label="ส่วนสูง"
                fullWidth
                error={!!error}
                type="number"
                helperText={error ? error.message : null}
                {...field}
              />
            )}
            name="empHeight"
            control={control}
          />
        </Grid>
        <Grid item xs={3} sm={3}>
          <rhf.Controller
            render={({ field, fieldState: { error } }) => (
              <TextField
                variant="filled"
                label="หมู่โลหิต"
                fullWidth
                error={!!error}
                helperText={error ? error.message : null}
                {...field}
              />
            )}
            name="bloodType"
            control={control}
          />
        </Grid>
        <Grid item xs={3} sm={3}>
          <rhf.Controller
            render={({ field, fieldState: { error } }) => (
              <TextField
                variant="filled"
                label="ตำหนิ"
                fullWidth
                error={!!error}
                helperText={error ? error.message : null}
                {...field}
              />
            )}
            name="empWound"
            control={control}
          />
        </Grid>

        <Grid item xs={3} sm={3}>
          <rhf.Controller
            render={({ field, fieldState: { error } }) => (
              <TextField
                variant="filled"
                label="เชื้อชาติ"
                fullWidth
                error={!!error}
                helperText={error ? error.message : null}
                {...field}
              />
            )}
            name="empOrigin"
            control={control}
          />
        </Grid>
        <Grid item xs={3} sm={3}>
          <rhf.Controller
            render={({ field, fieldState: { error } }) => (
              <TextField
                variant="filled"
                label="สัญชาติ"
                fullWidth
                error={!!error}
                helperText={error ? error.message : null}
                {...field}
              />
            )}
            name="empNationality"
            control={control}
          />
        </Grid>
        <Grid item xs={3} sm={3}>
          <rhf.Controller
            render={({ field, fieldState: { error } }) => (
              <TextField
                variant="filled"
                label="ศาสนา"
                fullWidth
                error={!!error}
                helperText={error ? error.message : null}
                {...field}
              />
            )}
            name="empReligion"
            control={control}
          />
        </Grid>
        <Grid item xs={3} sm={3}></Grid>

        <Grid item xs={4} sm={4}>
          <rhf.Controller
            render={({ field, fieldState: { error } }) => (
              <TextField
                variant="filled"
                label="สัญชาติเดิม"
                fullWidth
                error={!!error}
                helperText={error ? error.message : null}
                {...field}
              />
            )}
            name="empOriginalNationality"
            control={control}
          />
        </Grid>
        <Grid item xs={4} sm={4}>
          {/* {JSON.stringify(formikProps.file1Name)} */}
          {/* <FileUpload /> */}
          <FileUpload
            {...props}
            rhf={rhf}
            control={control}
            msg1={` หลักฐานการเปลี่่ยนสัญชาติ`}
            formikName={`file2Name`}
            // rdxFileData={file2Data}
            // rdxSetFileData={setFile2Data}
          />
        </Grid>
        <Grid item xs={4} sm={4}></Grid>

        <Grid item xs={4} sm={4}>
          {/* <Paper elevation={1}> */}
          <Typography
            sx={{ pb: 0, pt: 1, pl: 2 }}
            variant="subtitle1"
            gutterBottom
          >
            กรณีเป็นต่างด้าว
          </Typography>
          <RadioFieldRHF
            name="isForeigner"
            // control={rhf.control}
            label="กรณีเป็นต่างด้าว"
            rhf={rhf}
            // errors={rhf.errors}
            options={optionsForeigner}
            // name={isForeigner.name}
            // setForeignValue={setForeignValue}
          />
          <FormHelperText>
            {rhf.errors?.isForeigner && rhf.errors.isForeigner.message}
          </FormHelperText>
          {/* </Paper> */}
        </Grid>
        <Grid item xs={4} sm={4}>
          <ForeignerFile control={control} />
        </Grid>
        <Grid item xs={4} sm={4}></Grid>

        {isForeignerOuter == 'Y' && (
          <>
            <Grid item xs={5} sm={5}>
              <rhf.Controller
                render={({ field, fieldState: { error } }) => (
                  <TextField
                    variant="filled"
                    label="ถ้าเป็นต่างด้าว ใบสำคัญถิ่นที่อยู่เลขที่"
                    fullWidth
                    error={!!error}
                    helperText={error ? error.message : null}
                    {...field}
                  />
                )}
                name="empForeignDocument1"
                control={control}
              />
            </Grid>
            <Grid item xs={3} sm={3}>
              <LocalizationProvider dateAdapter={AdapterDateFns} locale={th}>
                <rhf.Controller
                  control={control}
                  name="empForeignDocumentDate1"
                  render={({ field: { onChange, value = null } }) => (
                    <DesktopDatePicker
                      label="ลงวันที่"
                      inputFormat="dd/MM/yyyy"
                      value={value}
                      onChange={onChange}
                      renderInput={(params) => (
                        <TextField variant="filled" {...params} />
                      )}
                    />
                  )}
                />
              </LocalizationProvider>
            </Grid>
            <Grid item xs={4} sm={4}></Grid>
            <Grid item xs={5} sm={5}>
              <rhf.Controller
                render={({ field, fieldState: { error } }) => (
                  <TextField
                    variant="filled"
                    label="ใบสำคัญประจำตัวคนต่างด้าวเลขที่"
                    fullWidth
                    error={!!error}
                    helperText={error ? error.message : null}
                    {...field}
                  />
                )}
                name="empForeignDocument2"
                control={control}
              />
            </Grid>
            <Grid item xs={3} sm={3}>
              <LocalizationProvider dateAdapter={AdapterDateFns} locale={th}>
                <rhf.Controller
                  control={control}
                  name="empForeignDocumentDate2"
                  render={({ field: { onChange, value = null } }) => (
                    <DesktopDatePicker
                      label="ลงวันที่"
                      inputFormat="dd/MM/yyyy"
                      value={value}
                      onChange={onChange}
                      renderInput={(params) => (
                        <TextField variant="filled" {...params} />
                      )}
                    />
                  )}
                />
              </LocalizationProvider>
            </Grid>
            <Grid item xs={4} sm={4}></Grid>
            <Grid item xs={4} sm={4}>
              <rhf.Controller
                render={({ field, fieldState: { error } }) => (
                  <TextField
                    variant="filled"
                    label="ออกให้ ณ"
                    fullWidth
                    error={!!error}
                    helperText={error ? error.message : null}
                    {...field}
                  />
                )}
                name="empForeignIssuePlace"
                control={control}
              />
            </Grid>
            <Grid item xs={4} sm={4}>
              <rhf.Controller
                render={({ field, fieldState: { error } }) => (
                  <TextField
                    variant="filled"
                    label="อำเภอ/เขต"
                    fullWidth
                    error={!!error}
                    helperText={error ? error.message : null}
                    {...field}
                  />
                )}
                name="empForeignAmpher"
                control={control}
              />
            </Grid>
            <Grid item xs={4} sm={4}>
              <Province rhf={rhf} control={control} name="empForeignProvince" />
            </Grid>
            <Grid item xs={4} sm={4}>
              <rhf.Controller
                render={({ field, fieldState: { error } }) => (
                  <TextField
                    variant="filled"
                    label="ประเทศมาตุภูมิ"
                    fullWidth
                    error={!!error}
                    helperText={error ? error.message : null}
                    {...field}
                  />
                )}
                name="empForeignMotherland"
                control={control}
              />
            </Grid>
            <Grid item xs={4} sm={4}>
              <LocalizationProvider dateAdapter={AdapterDateFns} locale={th}>
                <rhf.Controller
                  control={control}
                  name="empForeignSettleDate"
                  render={({ field: { onChange, value = null } }) => (
                    <DesktopDatePicker
                      label="วัน เดือน ปี ที่เข้าประเทศไทย"
                      inputFormat="dd/MM/yyyy"
                      value={value}
                      onChange={onChange}
                      renderInput={(params) => (
                        <TextField variant="filled" fullWidth {...params} />
                      )}
                    />
                  )}
                />
              </LocalizationProvider>
            </Grid>
            <Grid item xs={4} sm={4}></Grid>
          </>
        )}
        <Grid item xs={12} sm={12}></Grid>

        <Grid item xs={4} sm={4}>
          {/* <Paper elevation={1}> */}
          <Typography
            sx={{ pb: 0, pt: 1, pl: 2 }}
            variant="subtitle1"
            gutterBottom
          >
            โรคประจำตัว
          </Typography>
          <RadioFieldRHF
            name="medicalProblem"
            label="ระบุโรคประจำตัว"
            rhf={rhf}
            options={optionsMedicalProblem}
            // initial '' ที่ EmploymentPage ด้วย
          />
          <FormHelperText error={true}>
            {rhf.errors?.medicalProblem && rhf.errors.medicalProblem.message}
          </FormHelperText>
          {/* </Paper> */}
        </Grid>
        <Grid item xs={4} sm={4}>
          <MedicalProblem control={control} />
        </Grid>
        <Grid item xs={4} sm={4}></Grid>
      </Grid>

      <Box p={0} display="flex" sx={{ pb: 0, pt: 6 }}>
        <H3>ที่อยู่</H3>
      </Box>
      <Divider sx={{ mb: 3 }} />
      <Grid container spacing={2}>
        <Grid item xs={12} sm={12}>
          <Typography sx={{ pb: 0, pt: 0 }} variant="subtitle1" gutterBottom>
            ที่อยู่ในระยะ 15 ปีที่ผ่านมา
          </Typography>
          <Typography sx={{ pb: 0, pt: 0 }} variant="subtitle1" gutterBottom>
            *ประวัติการพักอาศัยย้อนหลังที่มีการย้ายทะเบียนบ้าน
            หากไม่เคยย้ายให้ลงที่อยู่ปัจจุบันด้วย
          </Typography>
        </Grid>

        {fields.map((item, index) => {
          return (
            <>
              <Grid
                item
                xs={2}
                sm={2}
                component={Stack}
                justifyContent="flex-start"
                alignItems="flex-end"
              >
                <Typography
                  sx={{
                    pb: 0,
                    pt: 0,
                    color: 'success.main',
                  }}
                  variant="subtitle1"
                  gutterBottom
                >
                  {index != 0 && `ที่อยู่ที่ ${index + 1}`}
                </Typography>
              </Grid>

              <Grid item xs={2} sm={2}>
                {index != 0 && (
                  <Button
                    variant="outlined"
                    startIcon={<DeleteOutlineIcon />}
                    onClick={() => remove(index)}
                  >
                    ลบ
                  </Button>
                )}
              </Grid>
              <Grid item xs={8} sm={8}></Grid>

              {/* <Grid item xs={2} sm={2}>
                <div key={item.id}>
                  <rhf.Controller
                    render={({ field, fieldState: { error } }) => (
                      <TextField
                        variant="filled"
                        label="ระยะเวลา (ปี)"
                        fullWidth
                        type="number"
                        error={!!error}
                        InputProps={{
                          inputProps: {
                            max: 50,
                            min: 1,
                          },
                        }}
                        helperText={error ? error.message : null}
                        {...field}
                      />
                    )}
                    name={`addressPass15yr[${index}].year`}
                    control={control}
                  />
                </div>
              </Grid> */}
              <Grid item xs={2} sm={2}>
                <LocalizationProvider dateAdapter={AdapterDateFns} locale={th}>
                  <rhf.Controller
                    control={control}
                    name={`addressPass15yr[${index}].yearFrom`}
                    render={({ field: { onChange, value = null } }) => (
                      <DatePicker
                        views={['year']}
                        label="ระยะเวลาจาก"
                        // inputFormat="dd/MM/yyyy"
                        value={value}
                        onChange={onChange}
                        renderInput={(params) => (
                          <TextField variant="filled" fullWidth {...params} />
                        )}
                      />
                    )}
                  />
                </LocalizationProvider>
                {/* <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <rhf.Controller
                    control={control}
                    name={`addressPass15yr[${index}].dateFrom`}
                    render={({ field: { onChange, value = null } }) => (
                      <DesktopDatePicker
                        label="จาก"
                        inputFormat="dd/MM/yyyy"
                        value={value}
                        onChange={onChange}
                        renderInput={(params) => (
                          <TextField variant="filled" fullWidth {...params} />
                        )}
                      />
                    )}
                  />
                </LocalizationProvider> */}
              </Grid>
              <Grid item xs={2} sm={2}>
                <LocalizationProvider dateAdapter={AdapterDateFns} locale={th}>
                  <rhf.Controller
                    control={control}
                    name={`addressPass15yr[${index}].yearTo`}
                    render={({ field: { onChange, value = null } }) => (
                      <DatePicker
                        views={['year']}
                        label="ถึง"
                        // inputFormat="dd/MM/yyyy"
                        value={value}
                        onChange={onChange}
                        renderInput={(params) => (
                          <TextField variant="filled" fullWidth {...params} />
                        )}
                      />
                    )}
                  />
                </LocalizationProvider>
                {/* <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <rhf.Controller
                    control={control}
                    name={`addressPass15yr[${index}].dateTo`}
                    render={({ field: { onChange, value = null } }) => (
                      <DesktopDatePicker
                        label="ถึง"
                        inputFormat="dd/MM/yyyy"
                        value={value}
                        onChange={onChange}
                        renderInput={(params) => (
                          <TextField variant="filled" fullWidth {...params} />
                        )}
                      />
                    )}
                  />
                </LocalizationProvider> */}
              </Grid>
              <Grid item xs={8} sm={8}>
                <rhf.Controller
                  render={({ field, fieldState: { error } }) => (
                    <TextField
                      variant="filled"
                      label="บ้านเลขที่ หมู่ที่ หมู่บ้าน อาคาร ซอย ถนน"
                      fullWidth
                      error={!!error}
                      helperText={error ? error.message : null}
                      {...field}
                    />
                  )}
                  name={`addressPass15yr[${index}].addressNo`}
                  control={control}
                />
              </Grid>
              {/* <Grid item xs={2} sm={2}>
                <rhf.Controller
                  render={({ field, fieldState: { error } }) => (
                    <TextField
                      variant="filled"
                      label="หมู่ที่"
                      fullWidth
                      error={!!error}
                      helperText={error ? error.message : null}
                      {...field}
                    />
                  )}
                  name={`addressPass15yr[${index}].moo`}
                  control={control}
                />
              </Grid>
              <Grid item xs={4} sm={4}>
                <rhf.Controller
                  render={({ field, fieldState: { error } }) => (
                    <TextField
                      variant="filled"
                      label="ซอย"
                      fullWidth
                      error={!!error}
                      helperText={error ? error.message : null}
                      {...field}
                    />
                  )}
                  name={`addressPass15yr[${index}].soi`}
                  control={control}
                />
              </Grid>
              <Grid item xs={4} sm={4}>
                <rhf.Controller
                  render={({ field, fieldState: { error } }) => (
                    <TextField
                      variant="filled"
                      label="ถนน"
                      fullWidth
                      error={!!error}
                      helperText={error ? error.message : null}
                      {...field}
                    />
                  )}
                  name={`addressPass15yr[${index}].road`}
                  control={control}
                />
              </Grid> */}
              <Grid item xs={4} sm={4}>
                <rhf.Controller
                  render={({ field, fieldState: { error } }) => (
                    <TextField
                      variant="filled"
                      label="ตำบล"
                      fullWidth
                      error={!!error}
                      helperText={error ? error.message : null}
                      {...field}
                    />
                  )}
                  name={`addressPass15yr[${index}].tambol`}
                  control={control}
                />
              </Grid>
              <Grid item xs={4} sm={4}>
                <rhf.Controller
                  render={({ field, fieldState: { error } }) => (
                    <TextField
                      variant="filled"
                      label="เขต/อำเภอ"
                      fullWidth
                      error={!!error}
                      helperText={error ? error.message : null}
                      {...field}
                    />
                  )}
                  name={`addressPass15yr[${index}].district`}
                  control={control}
                />
              </Grid>
              <Grid item xs={4} sm={4}>
                <Province
                  rhf={rhf}
                  control={control}
                  name={`addressPass15yr[${index}].province`}
                />
                {/* <rhf.Controller
                  render={({ field, fieldState: { error } }) => (
                    <TextField
                      variant="filled"
                      label="จังหวัด"
                      fullWidth
                      error={!!error}
                      helperText={error ? error.message : null}
                      {...field}
                    />
                  )}
                  name={`addressPass15yr[${index}].district`}
                  control={control}
                /> */}
              </Grid>
              <Grid item xs={3} sm={3}>
                <rhf.Controller
                  render={({ field, fieldState: { error } }) => (
                    <TextField
                      variant="filled"
                      label="รหัสไปรษณีย์"
                      fullWidth
                      error={!!error}
                      helperText={error ? error.message : null}
                      {...field}
                    />
                  )}
                  name={`addressPass15yr[${index}].postal`}
                  control={control}
                />
              </Grid>
              <Grid item xs={3} sm={3}>
                {/* ประเทศ */}
                <Country
                  rhf={rhf}
                  control={control}
                  name={`addressPass15yr[${index}].country`}
                ></Country>
                {/* <TextField
                  id="filled-basic"
                  label="ประเทศ"
                  variant="filled"
                  fullWidth
                /> */}
              </Grid>
              <Grid item xs={6} sm={6}></Grid>

              {/* <Grid item xs={3} sm={3}>
                <CheckboxAddress1
                  control={control}
                  index={index}
                  replace={replace}
                />
              </Grid> */}
              {/* <Grid item xs={4} sm={4}>
                <label style={{ color: '#A9A9A9' }}>
                  ที่อยู่ปัจจุบันที่สามารถติดต่อได้
                </label>
                <rhf.Controller
                  name={`addressPass15yr[${index}].isContactAddress`}
                  control={control}
                  render={({ field }) => (
                    <Checkbox
                      onChange={(e) => field.onChange(e.target.checked)}
                      checked={field.value}
                    />
                  )}
                />
              </Grid>
              <Grid item xs={5} sm={5}></Grid> */}

              <Grid item xs={12} sm={12}></Grid>
            </>
          );
        })}
        <Grid item xs={2} sm={2}>
          <Button
            variant="outlined"
            onClick={() => {
              append({ name: '', year: '' });
            }}
          >
            + เพิ่มที่อยู่
          </Button>
        </Grid>

        {/* 
        |
        |
        | ที่อยู่ตามทะเบียนบ้าน
        |
        |
        */}
        <Grid item xs={12} sm={12}>
          <Typography sx={{ pb: 0, pt: 7 }} variant="subtitle1" gutterBottom>
            ที่อยู่ตามทะเบียนบ้าน
          </Typography>
        </Grid>
        <Grid item xs={9} sm={9}>
          <rhf.Controller
            render={({ field, fieldState: { error } }) => (
              <TextField
                variant="filled"
                label="หมู่บ้าน อาคาร บ้านเลขที่ หมู่ที่ ซอย ถนน "
                fullWidth
                error={!!error}
                helperText={error ? error.message : null}
                {...field}
              />
            )}
            name="registAddressNo"
            control={control}
          />
        </Grid>
        <Grid item xs={3} sm={3}></Grid>
        {/* <Grid item xs={2} sm={2}>
          <rhf.Controller
            render={({ field, fieldState: { error } }) => (
              <TextField
                variant="filled"
                label="หมู่ที่"
                fullWidth
                error={!!error}
                helperText={error ? error.message : null}
                {...field}
              />
            )}
            name="registAddressMoo"
            control={control}
          />
        </Grid>
        <Grid item xs={4} sm={4}>
          <rhf.Controller
            render={({ field, fieldState: { error } }) => (
              <TextField
                variant="filled"
                label="ซอย"
                fullWidth
                error={!!error}
                helperText={error ? error.message : null}
                {...field}
              />
            )}
            name="registAddressSoi"
            control={control}
          />
        </Grid>
        <Grid item xs={4} sm={4}>
          <rhf.Controller
            render={({ field, fieldState: { error } }) => (
              <TextField
                variant="filled"
                label="ถนน"
                fullWidth
                error={!!error}
                helperText={error ? error.message : null}
                {...field}
              />
            )}
            name="registAddressRoad"
            control={control}
          />
        </Grid> */}
        {/* <Grid item xs={3} sm={3}>
          <rhf.Controller
            render={({ field, fieldState: { error } }) => (
              <TextField
                variant="filled"
                label="ตำบล"
                fullWidth
                error={!!error}
                helperText={error ? error.message : null}
                {...field}
              />
            )}
            name="registAddressTambol"
            control={control}
          />
        </Grid> */}
        {/* ตำบล */}
        <Grid item xs={3} sm={3}>
          <Tambol
            rhf={rhf}
            control={control}
            name="homeAddressTambol"
            province={checkHomeAddressProvince}
            district={checkHomeAddressDistrict}
          />
        </Grid>
        {/* อำเภอ */}
        <Grid item xs={3} sm={3}>
          <District
            rhf={rhf}
            control={control}
            name="homeAddressDistrict"
            province={checkHomeAddressProvince}
          />
        </Grid>
        {/* <Grid item xs={3} sm={3}>
          <rhf.Controller
            render={({ field, fieldState: { error } }) => (
              <TextField
                variant="filled"
                label="เขต/อำเภอ"
                fullWidth
                error={!!error}
                helperText={error ? error.message : null}
                {...field}
              />
            )}
            name="registAddressDistrict"
            control={control}
          />
        </Grid> */}
        <Grid item xs={3} sm={3}>
          <Province rhf={rhf} control={control} name="homeAddressProvince" />
        </Grid>
        <Grid item xs={3} sm={3}>
          <rhf.Controller
            render={({ field, fieldState: { error } }) => (
              <TextField
                variant="filled"
                label="รหัสไปรษณีย์"
                fullWidth
                error={!!error}
                helperText={error ? error.message : null}
                {...field}
              />
            )}
            name="homeAddressPostal"
            control={control}
          />
        </Grid>

        <Grid item xs={12} sm={12}>
          <Typography sx={{ pb: 0, pt: 7 }} variant="subtitle1" gutterBottom>
            ที่อยู่ปัจจุบันที่สามารถติดต่อได้
          </Typography>
        </Grid>
        <Grid item xs={9} sm={9}>
          <rhf.Controller
            render={({ field, fieldState: { error } }) => (
              <TextField
                variant="filled"
                label="บ้านเลขที่ หมู่ที่ อาคาร หมู่บ้าน ซอย ถนน"
                fullWidth
                error={!!error}
                helperText={error ? error.message : null}
                {...field}
              />
            )}
            name="presentAddressNo"
            control={control}
          />
        </Grid>
        <Grid item xs={3} sm={3}></Grid>
        {/* <Grid item xs={2} sm={2}>
          <rhf.Controller
            render={({ field, fieldState: { error } }) => (
              <TextField
                variant="filled"
                label="หมู่ที่"
                fullWidth
                error={!!error}
                helperText={error ? error.message : null}
                {...field}
              />
            )}
            name="presentAddressMoo"
            control={control}
          />
        </Grid>
        <Grid item xs={4} sm={4}>
          <rhf.Controller
            render={({ field, fieldState: { error } }) => (
              <TextField
                variant="filled"
                label="ซอย"
                fullWidth
                error={!!error}
                helperText={error ? error.message : null}
                {...field}
              />
            )}
            name="presentAddressSoi"
            control={control}
          />
        </Grid>
        <Grid item xs={4} sm={4}>
          <rhf.Controller
            render={({ field, fieldState: { error } }) => (
              <TextField
                variant="filled"
                label="ถนน"
                fullWidth
                error={!!error}
                helperText={error ? error.message : null}
                {...field}
              />
            )}
            name="presentAddressRoad"
            control={control}
          />
        </Grid> */}
        <Grid item xs={3} sm={3}>
          {/* <rhf.Controller
            render={({ field, fieldState: { error } }) => (
              <TextField
                variant="filled"
                label="ตำบล"
                fullWidth
                error={!!error}
                helperText={error ? error.message : null}
                {...field}
              />
            )}
            name="presentAddressTambol"
            control={control}
          /> */}
          <Tambol
            rhf={rhf}
            control={control}
            name="presentAddressTambol"
            province={checkPresentAddressProvince}
            district={checkPresentAddressDistrict}
          />
        </Grid>
        <Grid item xs={3} sm={3}>
          {/* อำเภอ */}
          <District
            rhf={rhf}
            control={control}
            name="presentAddressDistrict"
            province={checkPresentAddressProvince}
          />
          {/* <rhf.Controller
            render={({ field, fieldState: { error } }) => (
              <TextField
                variant="filled"
                label="เขต/อำเภอ"
                fullWidth
                error={!!error}
                helperText={error ? error.message : null}
                {...field}
              />
            )}
            name="presentAddressDistrict"
            control={control}
          /> */}
        </Grid>
        <Grid item xs={3} sm={3}>
          {/* จังหวัด */}
          <Province rhf={rhf} control={control} name="presentAddressProvince" />
        </Grid>
        <Grid item xs={3} sm={3}>
          <rhf.Controller
            render={({ field, fieldState: { error } }) => (
              <TextField
                variant="filled"
                label="รหัสไปรษณีย์"
                fullWidth
                error={!!error}
                helperText={error ? error.message : null}
                {...field}
              />
            )}
            name="presentAddressPostal"
            control={control}
          />
        </Grid>
        <Grid item xs={4} sm={4}>
          <rhf.Controller
            render={({ field, fieldState: { error } }) => (
              <TextField
                variant="filled"
                label="โทรศัพท์มือถือ"
                fullWidth
                error={!!error}
                helperText={error ? error.message : null}
                {...field}
              />
            )}
            name="presentAddressCellPhone"
            control={control}
          />
        </Grid>
        <Grid item xs={5} sm={5}>
          <rhf.Controller
            render={({ field, fieldState: { error } }) => (
              <TextField
                variant="filled"
                label="E-mail"
                fullWidth
                error={!!error}
                helperText={error ? error.message : null}
                {...field}
              />
            )}
            name="presentAddressEmail"
            control={control}
          />
        </Grid>
        <Grid item xs={3} sm={3}></Grid>

        <Grid item xs={12} sm={12}>
          <Typography sx={{ pb: 0, pt: 7 }} variant="subtitle1" gutterBottom>
            บุคคลที่ติดต่อได้ในกรณีเร่งด่วน
          </Typography>
        </Grid>
        <Grid item xs={2} sm={2}>
          <FormControl error={rhf.errors.title} variant="filled" fullWidth>
            <InputLabel>คำนำหน้า</InputLabel>
            <Controller
              render={({ field: { onChange, value } }) => (
                <Select onChange={onChange} value={value}>
                  {titleOptions.map((title) => (
                    <MenuItem key={title.value} value={title.value}>
                      {title.label}
                    </MenuItem>
                  ))}
                </Select>
              )}
              control={control}
              name="emergencyTitle"
            />
            <FormHelperText error={rhf.errors.title}>
              {rhf.errors.title ? '(' + rhf.errors.title.message + ')' : ''}
            </FormHelperText>
          </FormControl>
        </Grid>
        <Grid item xs={3} sm={3}>
          <rhf.Controller
            render={({ field, fieldState: { error } }) => (
              <TextField
                variant="filled"
                label="ชื่อ"
                fullWidth
                error={!!error}
                helperText={error ? error.message : null}
                {...field}
              />
            )}
            name="emergencyFirstname"
            control={control}
          />
        </Grid>
        <Grid item xs={3} sm={3}>
          <rhf.Controller
            render={({ field, fieldState: { error } }) => (
              <TextField
                variant="filled"
                label="สกุล"
                fullWidth
                error={!!error}
                helperText={error ? error.message : null}
                {...field}
              />
            )}
            name="emergencyLastname"
            control={control}
          />
        </Grid>
        <Grid item xs={2} sm={2}>
          <rhf.Controller
            render={({ field, fieldState: { error } }) => (
              <TextField
                variant="filled"
                label="เกี่ยวข้องเป็น"
                fullWidth
                error={!!error}
                helperText={error ? error.message : null}
                {...field}
              />
            )}
            name="emergencyRelation"
            control={control}
          />
        </Grid>
        <Grid item xs={2} sm={2}></Grid>

        <Grid item xs={7} sm={7}>
          <rhf.Controller
            render={({ field, fieldState: { error } }) => (
              <TextField
                variant="filled"
                label="ที่อยู่"
                fullWidth
                error={!!error}
                helperText={error ? error.message : null}
                {...field}
              />
            )}
            name="emergencyAddress"
            control={control}
          />
        </Grid>
        <Grid item xs={3} sm={3}>
          <rhf.Controller
            render={({ field, fieldState: { error } }) => (
              <TextField
                variant="filled"
                label="โทรศัพท์"
                fullWidth
                error={!!error}
                helperText={error ? error.message : null}
                {...field}
              />
            )}
            name="emergencyPhone"
            control={control}
          />
        </Grid>
        <Grid item xs={2} sm={2}></Grid>
      </Grid>

      {/* <Grid item xs={12} sm={12}>
          <Typography sx={{ pb: 0, pt: 5 }} variant="subtitle1" gutterBottom>
            ไปปฏิบัติงานต่างจังหวัด
          </Typography>
        </Grid> */}
      <Box p={0} display="flex" sx={{ pb: 0, pt: 8 }}>
        <H3>ไปปฏิบัติงานต่างจังหวัด</H3>
      </Box>
      <Divider sx={{ mb: 2 }} />
      <Grid container spacing={2}>
        <Grid item xs={4} sm={4}>
          <Paper elevation={1}>
            <Typography
              sx={{ pb: 2, pt: 1, pl: 2, pr: 2 }}
              variant="subtitle1"
              gutterBottom
            >
              หากต้องไปปฏิบัติงานต่างจังหวัดเป็นการประจำ
            </Typography>
            <RadioFieldRHF
              name="workOnRemoteSite"
              label="ไปปฏิบัติงานต่างจังหวัด"
              rhf={rhf}
              options={optionsWorkOnRemoteSite}
              // initial '' ที่ EmploymentPage ด้วย
            />
          </Paper>
        </Grid>
        <Grid item xs={4} sm={4}>
          <Paper elevation={1}>
            <Typography
              sx={{ pb: 2, pt: 1, pl: 2, pr: 2 }}
              variant="subtitle1"
              gutterBottom
            >
              หากต้องไปปฏิบัติงานต่างจังหวัดเป็นครั้งคราว
            </Typography>
            <RadioFieldRHF
              name="workOnRemoteSiteOccasion"
              label="ไปปฏิบัติงานต่างจังหวัดเป็นครั้งคราว"
              rhf={rhf}
              options={optionsWorkOnRemoteSite}
              // initial '' ที่ EmploymentPage ด้วย
            />
          </Paper>
        </Grid>
        <Grid item xs={4} sm={4}></Grid>
      </Grid>

      {/* 
      |
      |
      | ประวัติการศึกษา
      |
      |
      */}
      <Box p={0} display="flex" sx={{ pb: 0, pt: 7 }}>
        <H3>ประวัติการศึกษา</H3>
      </Box>
      <Divider sx={{ mb: 2 }} />
      <Grid container spacing={2}>
        <Grid item xs={12} sm={12}>
          <Typography sx={{ pb: 0, pt: 0 }} variant="subtitle1" gutterBottom>
            ประวัติการศึกษาตั้งแต่ชั้นอนุบาล จนถึงชั้นสูงสุดที่สำเร็จการศึกษา
          </Typography>
        </Grid>

        {eduFields.map((item, index) => {
          return (
            <>
              <Grid
                item
                xs={2}
                sm={2}
                component={Stack}
                justifyContent="flex-start"
                alignItems="flex-end"
              >
                <Typography
                  sx={{
                    pb: 0,
                    pt: 0,
                    color: 'success.main',
                  }}
                  variant="subtitle1"
                  gutterBottom
                >
                  {index != 0 && `การศึกษาที่ ${index + 1}`}
                </Typography>
              </Grid>
              <Grid item xs={2} sm={2}>
                {index != 0 && (
                  <Button
                    variant="outlined"
                    startIcon={<DeleteOutlineIcon />}
                    onClick={() => eduRemove(index)}
                  >
                    ลบ
                  </Button>
                )}
              </Grid>
              <Grid item xs={8} sm={8}></Grid>
              {/* <Grid item xs={2} sm={2}>
                <div key={item.id}>
                  <rhf.Controller
                    render={({ field, fieldState: { error } }) => (
                      <TextField
                        variant="filled"
                        label="ระยะเวลา (ปี)"
                        fullWidth
                        type="number"
                        error={!!error}
                        InputProps={{
                          inputProps: {
                            max: 50,
                            min: 1,
                          },
                        }}
                        helperText={error ? error.message : null}
                        {...field}
                      />
                    )}
                    name={`educations[${index}].period`}
                    control={control}
                  />
                </div>
              </Grid> */}

              <Grid item xs={3} sm={3}>
                <FormControl
                  // error={rhf.errors.rankingType}
                  variant="filled"
                  fullWidth
                >
                  <InputLabel>ระดับชั้น / หลักสูตร</InputLabel>
                  <Controller
                    render={({ field: { onChange, value } }) => (
                      <Select onChange={onChange} value={value} defaultValue="">
                        {eduClass.map((clss) => (
                          <MenuItem key={clss.code} value={clss.code}>
                            {clss.name}
                          </MenuItem>
                        ))}
                      </Select>
                    )}
                    control={control}
                    name={`educations[${index}].eduClass`}
                  />
                  {/* gg: react-hook-form field array errors */}
                  <FormHelperText
                    error={rhf.errors.educations?.[index].eduClass}
                  >
                    {rhf.errors.educations?.[index].eduClass
                      ? '(' +
                        rhf.errors.educations?.[index].eduClass?.message +
                        ')'
                      : ''}
                  </FormHelperText>
                </FormControl>
              </Grid>
              <Grid item xs={7} sm={7}>
                <rhf.Controller
                  render={({ field, fieldState: { error } }) => (
                    <TextField
                      variant="filled"
                      label="ชื่อและที่ตั้งสถานศึกษา"
                      fullWidth
                      error={!!error}
                      helperText={error ? error.message : null}
                      {...field}
                    />
                  )}
                  name={`educations[${index}].eduNameAndPlace`}
                  control={control}
                />
              </Grid>
              <Grid item xs={2} sm={2}></Grid>
              {/* gg: mui year picker */}
              <Grid item xs={3} sm={3}>
                <LocalizationProvider dateAdapter={AdapterDateFns} locale={th}>
                  <rhf.Controller
                    control={control}
                    name={`educations[${index}].dateFrom`}
                    render={({ field: { onChange, value = null } }) => (
                      <DatePicker
                        views={['year']}
                        label="ระยะเวลาจาก"
                        // inputFormat="dd/MM/yyyy"
                        value={value}
                        onChange={onChange}
                        renderInput={(params) => (
                          <TextField variant="filled" fullWidth {...params} />
                        )}
                      />
                    )}
                  />
                </LocalizationProvider>
              </Grid>
              <Grid item xs={3} sm={3}>
                <LocalizationProvider dateAdapter={AdapterDateFns} locale={th}>
                  <rhf.Controller
                    control={control}
                    name={`educations[${index}].dateTo`}
                    render={({ field: { onChange, value = null } }) => (
                      <DatePicker
                        views={['year']}
                        label="ถึง"
                        // inputFormat="dd/MM/yyyy"
                        value={value}
                        onChange={onChange}
                        renderInput={(params) => (
                          <TextField variant="filled" fullWidth {...params} />
                        )}
                      />
                    )}
                  />
                  {/* <rhf.Controller
                    control={control}
                    name={`educations[${index}].dateTo`}
                    render={({ field: { onChange, value = null } }) => (
                      <DesktopDatePicker
                        label="ถึง"
                        inputFormat="dd/MM/yyyy"
                        value={value}
                        onChange={onChange}
                        renderInput={(params) => (
                          <TextField variant="filled" fullWidth {...params} />
                        )}
                      />
                    )}
                  /> */}
                </LocalizationProvider>
              </Grid>
              <Grid item xs={4} sm={4}>
                <rhf.Controller
                  render={({ field, fieldState: { error } }) => (
                    <TextField
                      variant="filled"
                      label="เกรดเฉลี่ย/ผลการศึกษา"
                      fullWidth
                      error={!!error}
                      helperText={error ? error.message : null}
                      {...field}
                    />
                  )}
                  name={`educations[${index}].eduGradeScore`}
                  control={control}
                />
              </Grid>
              <Grid item xs={2} sm={2}></Grid>

              <EduClassDegree
                control={control}
                index={index}
                rhf={rhf}
                // replace={replace}
              />

              <Grid item xs={12} sm={12}></Grid>
            </>
          );
        })}
        <Grid item xs={2} sm={2}>
          <Button
            variant="outlined"
            onClick={() => {
              eduAppend({ period: '' });
            }}
          >
            + เพิ่มการศึกษา
          </Button>
        </Grid>

        <Grid item xs={4} sm={4}></Grid>
        <Grid item xs={4} sm={4}></Grid>
        <Grid item xs={4} sm={4}></Grid>
      </Grid>

      <Box p={0} display="flex" sx={{ pb: 0, pt: 7 }}>
        <H3>ระดับการศึกษา/คุณวุฒิที่สมัคร</H3>
      </Box>
      <Divider sx={{ mb: 2 }} />
      <Grid container spacing={2}>
        <Grid item xs={12} sm={12}>
          <Paper elevation={1}>
            <RadioFieldRHFRow
              name="eduOnApplicant"
              label="eduOnApplicant-label"
              rhf={rhf}
              options={eduOnApplicant}
              error={rhf.errors.eduOnApplicant}
              // initial '' ที่ EmploymentPage ด้วย
            />
          </Paper>
        </Grid>
      </Grid>

      <Box p={0} display="flex" sx={{ pb: 0, pt: 7 }}>
        <H3>ใบอนุญาตประกอบวิชาชีพวิศวกรรม (ถ้ามี)</H3>
      </Box>
      <Divider sx={{ mb: 2 }} />
      <Grid container spacing={2}>
        <Grid item xs={12} sm={12}>
          <Typography sx={{ pb: 0, pt: 0 }} variant="subtitle1" gutterBottom>
            **ใบอนุญาตประกอบวิชาชีพวิศวกรรมควบคุม ในสาขาตามที่กฎหมายกำหนด จำนวน
            7 สาขา ได้แก่ สาขาวิศวกรรมโยธา 
            วิศวกรรมเหมืองแร่ วิศวกรรมเครื่องกล วิศวกรรมไฟฟ้า วิศวกรรมอุตสาหการ วิศวกรรมสิ่งแวดล้อม และวิศวกรรมเคมี
            ต้องนำใบอนุญาตดังกล่าวมาแสดงต่อ กฟผ. ภายใน 1
            ปี นับแต่วันที่เข้าทำงานกับ กฟผ.
          </Typography>
        </Grid>
        <Grid item xs={12} sm={12}>
          <Paper elevation={1}>
            <RadioFieldRHFRow
              name="engineerCert"
              label="engineerCert-label"
              rhf={rhf}
              options={engineerCert}
              error={rhf.errors.engineerCert}
              // initial '' ที่ EmploymentPage ด้วย
            />
          </Paper>
        </Grid>
        {hasEngineerCert == 'Y' && (
          <>
            <Grid item xs={4} sm={4}>
              <rhf.Controller
                render={({ field, fieldState: { error } }) => (
                  <TextField
                    variant="filled"
                    label="เลขที่ใบประกอบวิชาชีพ"
                    fullWidth
                    error={!!error}
                    helperText={error ? error.message : null}
                    {...field}
                  />
                )}
                name="engineerCertNo"
                control={control}
              />
            </Grid>
            <Grid item xs={5} sm={5}>
              <rhf.Controller
                render={({ field, fieldState: { error } }) => (
                  <TextField
                    variant="filled"
                    label="หน่วยงานผู้ออกใบประกอบวิชาชีพ (ไม่เกิน 30 ตัวอักษร)"
                    fullWidth
                    error={!!error}
                    helperText={error ? error.message : null}
                    {...field}
                  />
                )}
                name="engineerCertNo"
                control={control}
              />
            </Grid>
            <Grid item xs={3} sm={3}></Grid>
            <Grid item xs={4} sm={4}>
              <LocalizationProvider dateAdapter={AdapterDateFns} locale={th}>
                {/* <LocalizationProvider adapterLocale={th}> */}
                <rhf.Controller
                  control={control}
                  name="engineerCertStartDate"
                  render={({ field: { onChange, value } }) => (
                    <DesktopDatePicker
                      label="วันอนุญาต"
                      inputFormat="dd/MM/yyyy"
                      value={value}
                      onChange={onChange}
                      renderInput={(params) => (
                        <TextField variant="filled" fullWidth {...params} />
                      )}
                    />
                  )}
                />
              </LocalizationProvider>
            </Grid>
            <Grid item xs={4} sm={4}>
              <LocalizationProvider dateAdapter={AdapterDateFns} locale={th}>
                {/* <LocalizationProvider adapterLocale={th}> */}
                <rhf.Controller
                  control={control}
                  name="engineerCertEndDate"
                  render={({ field: { onChange, value } }) => (
                    <DesktopDatePicker
                      label="วันหมดอายุ"
                      inputFormat="dd/MM/yyyy"
                      value={value}
                      onChange={onChange}
                      renderInput={(params) => (
                        <TextField variant="filled" fullWidth {...params} />
                      )}
                    />
                  )}
                />
              </LocalizationProvider>
            </Grid>
            <Grid item xs={4} sm={4}></Grid>
            <Grid item xs={4} sm={4}>
              <rhf.Controller
                render={({ field, fieldState: { error } }) => (
                  <TextField
                    variant="filled"
                    label="หมายเลขสมาชิกสภาวิศวกร"
                    fullWidth
                    error={!!error}
                    helperText={error ? error.message : null}
                    {...field}
                  />
                )}
                name="engineerCertNo"
                control={control}
              />
            </Grid>
            <Grid item xs={4} sm={4}>
              <FormControl
                error={rhf.errors.engineerCertType}
                variant="filled"
                fullWidth
              >
                <InputLabel>ประเภทใบ กว.</InputLabel>
                <Controller
                  render={({ field: { onChange, value } }) => (
                    <Select onChange={onChange} value={value} defaultValue="">
                      {engineerCertType.map((el) => (
                        <MenuItem key={el.value} value={el.value}>
                          {el.label}
                        </MenuItem>
                      ))}
                    </Select>
                  )}
                  control={control}
                  name={`engineerCertType`}
                />
                <FormHelperText error={rhf.errors.engineerCertType}>
                  {rhf.errors.engineerCertType
                    ? rhf.errors.engineerCertType.message
                    : ''}
                </FormHelperText>
              </FormControl>
            </Grid>
            <Grid item xs={4} sm={4}></Grid>
            <Grid item xs={4} sm={4}>
              <FormControl
                error={rhf.errors.engineerCertBranch}
                variant="filled"
                fullWidth
              >
                <InputLabel>สาขา</InputLabel>
                <Controller
                  render={({ field: { onChange, value } }) => (
                    <Select onChange={onChange} value={value} defaultValue="">
                      {engineerCertBranch.map((el) => (
                        <MenuItem key={el.value} value={el.value}>
                          {el.label}
                        </MenuItem>
                      ))}
                    </Select>
                  )}
                  control={control}
                  name={`engineerCertBranch`}
                />
                <FormHelperText error={rhf.errors.engineerCertBranch}>
                  {rhf.errors.engineerCertBranch
                    ? rhf.errors.engineerCertBranch.message
                    : ''}
                </FormHelperText>
              </FormControl>
            </Grid>
          </>
        )}
      </Grid>

      <Box p={0} display="flex" sx={{ pb: 0, pt: 7 }}>
        <H3>กิจกรรมพิเศษในสถานศึกษา (ถ้ามี)</H3>
      </Box>
      <Divider sx={{ mb: 2 }} />
      <Grid container spacing={2}>
        <Grid item xs={12} sm={12}>
          <Typography sx={{ pb: 0, pt: 0 }} variant="subtitle1" gutterBottom>
            *ประวัติการร่วมกิจกรรมในสถานศึกษา เช่น การออกค่ายอาสา
            การเป็นประธานชมรมในสถานศึกษา ไม่เกิน 3 กิจกรรม
          </Typography>
        </Grid>
        <Grid item xs={12} sm={12}>
          <Paper elevation={1}>
            <RadioFieldRHFRow
              name="isCollegeActivity"
              label="isCollegeActivity-label"
              rhf={rhf}
              options={collegeActivityOptions}
              error={rhf.errors.isCollegeActivity}
              // initial '' ที่ EmploymentPage ด้วย
            />
          </Paper>
        </Grid>

        {hasCollegeActivity == 'Y' &&
          collegeActivityFields.map((item, index) => {
            return (
              <>
                <Grid
                  item
                  xs={2}
                  sm={2}
                  component={Stack}
                  justifyContent="flex-start"
                  alignItems="flex-end"
                >
                  <Typography
                    sx={{
                      pb: 0,
                      pt: 0,
                      color: 'success.main',
                    }}
                    variant="subtitle1"
                    gutterBottom
                  >
                    {index != 0 && `กิจกรรมที่ ${index + 1}`}
                  </Typography>
                </Grid>
                <Grid item xs={2} sm={2}>
                  {index != 0 && (
                    <Button
                      variant="outlined"
                      startIcon={<DeleteOutlineIcon />}
                      onClick={() => collegeActivityRemove(index)}
                    >
                      ลบ
                    </Button>
                  )}
                </Grid>
                <Grid item xs={8} sm={8}></Grid>

                <Grid item xs={2} sm={2}>
                  <LocalizationProvider
                    dateAdapter={AdapterDateFns}
                    locale={th}
                  >
                    <rhf.Controller
                      control={control}
                      name={`collegeActivity[${index}].dateFrom`}
                      render={({
                        field: { onChange, value = null },
                        fieldState: { error },
                      }) => (
                        <DatePicker
                          views={['year']}
                          label="ระยะเวลาจาก"
                          // inputFormat="dd/MM/yyyy"
                          value={value}
                          onChange={onChange}
                          renderInput={(params) => (
                            <TextField
                              variant="filled"
                              fullWidth
                              {...params}
                              error={!!error}
                              helperText={error ? error.message : null}
                            />
                          )}
                        />
                      )}
                    />
                  </LocalizationProvider>
                </Grid>
                <Grid item xs={2} sm={2}>
                  <LocalizationProvider
                    dateAdapter={AdapterDateFns}
                    locale={th}
                  >
                    <rhf.Controller
                      control={control}
                      name={`collegeActivity[${index}].dateTo`}
                      render={({ field: { onChange, value = null } }) => (
                        <DatePicker
                          views={['year']}
                          label="ถึง"
                          // inputFormat="dd/MM/yyyy"
                          value={value}
                          onChange={onChange}
                          renderInput={(params) => (
                            <TextField variant="filled" fullWidth {...params} />
                          )}
                        />
                      )}
                    />
                  </LocalizationProvider>
                </Grid>
                <Grid item xs={4} sm={4}>
                  <rhf.Controller
                    render={({ field, fieldState: { error } }) => (
                      <TextField
                        variant="filled"
                        label="สถานศึกษา"
                        fullWidth
                        error={!!error}
                        helperText={error ? error.message : null}
                        {...field}
                      />
                    )}
                    name={`collegeActivity[${index}].collegeName`}
                    control={control}
                  />
                </Grid>
                <Grid item xs={4} sm={4}>
                  <rhf.Controller
                    render={({ field, fieldState: { error } }) => (
                      <TextField
                        variant="filled"
                        label="ตำแหน่งหน้าที่"
                        fullWidth
                        error={!!error}
                        helperText={error ? error.message : null}
                        {...field}
                      />
                    )}
                    name={`collegeActivity[${index}].duty`}
                    control={control}
                  />
                </Grid>

                <Grid item xs={12} sm={12}></Grid>
              </>
            );
          })}
        <Grid item xs={2} sm={2}>
          <Button
            variant="outlined"
            onClick={() => {
              hasCollegeActivity == 'Y' &&
                collegeActivityAppend({ period: '' });
            }}
          >
            + เพิ่มกิจกรรม
          </Button>
        </Grid>

        <Grid item xs={4} sm={4}></Grid>
        <Grid item xs={4} sm={4}></Grid>
        <Grid item xs={4} sm={4}></Grid>
      </Grid>

      {/* 
      |
      |
      | ภาษาต่างประเทศ
      |
      |
      */}
      <Box p={0} display="flex" sx={{ pb: 0, pt: 7 }}>
        <H3>ภาษาต่างประเทศ</H3>
      </Box>
      <Divider sx={{ mb: 2 }} />
      <Grid container spacing={2}>
        <Grid item xs={2} sm={2}>
          <Typography
            //margin-top : 2
            sx={{ pb: 0, pt: 0, mt: 2 }}
            variant="subtitle1"
            gutterBottom
          >
            ภาษาอังกฤษ
          </Typography>
        </Grid>
        <Grid item xs={2} sm={2}>
          <FormControl
            error={rhf.errors.englishLanguageSkillSpeak}
            variant="filled"
            fullWidth
          >
            <InputLabel>พูด</InputLabel>
            <Controller
              render={({ field: { onChange, value } }) => (
                <Select onChange={onChange} value={value}>
                  {languageSkill.map((level) => (
                    <MenuItem key={level.value} value={level.value}>
                      {level.label}
                    </MenuItem>
                  ))}
                </Select>
              )}
              control={control}
              name="englishLanguageSkillSpeak"
            />
            <FormHelperText error={rhf.errors.englishLanguageSkillSpeak}>
              {rhf.errors.englishLanguageSkillSpeak
                ? '(' + rhf.errors.englishLanguageSkillSpeak.message + ')'
                : ''}
            </FormHelperText>
          </FormControl>
        </Grid>
        <Grid item xs={2} sm={2}>
          <FormControl
            error={rhf.errors.englishLanguageSkillRead}
            variant="filled"
            fullWidth
          >
            <InputLabel>อ่าน</InputLabel>
            <Controller
              render={({ field: { onChange, value } }) => (
                <Select onChange={onChange} value={value}>
                  {languageSkill.map((level) => (
                    <MenuItem key={level.value} value={level.value}>
                      {level.label}
                    </MenuItem>
                  ))}
                </Select>
              )}
              control={control}
              name="englishLanguageSkillRead"
            />
            <FormHelperText error={rhf.errors.englishLanguageSkillRead}>
              {rhf.errors.englishLanguageSkillRead
                ? '(' + rhf.errors.englishLanguageSkillRead.message + ')'
                : ''}
            </FormHelperText>
          </FormControl>
        </Grid>
        <Grid item xs={2} sm={2}>
          <FormControl
            error={rhf.errors.englishLanguageSkillWrite}
            variant="filled"
            fullWidth
          >
            <InputLabel>เขียน</InputLabel>
            <Controller
              render={({ field: { onChange, value } }) => (
                <Select onChange={onChange} value={value}>
                  {languageSkill.map((level) => (
                    <MenuItem key={level.value} value={level.value}>
                      {level.label}
                    </MenuItem>
                  ))}
                </Select>
              )}
              control={control}
              name="englishLanguageSkillWrite"
            />
            <FormHelperText error={rhf.errors.englishLanguageSkillWrite}>
              {rhf.errors.englishLanguageSkillWrite
                ? '(' + rhf.errors.englishLanguageSkillWrite.message + ')'
                : ''}
            </FormHelperText>
          </FormControl>
        </Grid>
        <Grid item xs={3} sm={3}>
          <FormControl
            error={rhf.errors.englishLanguageCertificate}
            variant="filled"
            fullWidth
          >
            {/* https://stackoverflow.com/questions/62933583/material-ui-autocomplete-getoptionlabel-passing-empty-string-as-value
            https://stackoverflow.com/questions/71485196/react-hook-form-with-mui-autocomplete-freesolo-and-dependent-fields
            https://codesandbox.io/s/react-hook-form-v6-controller-qsd8r?file=/src/MuiAutoComplete.js
            https://mui.com/material-ui/react-autocomplete/#free-solo
            https://medium.com/nerd-for-tech/demystifying-errors-in-mui-autocomplete-part-i-e306f922a906 */}
            <rhf.Controller
              render={({ field, fieldState: { error }, value }) => (
                <Autocomplete
                  {...field}
                  freeSolo
                  id="languageSkillSelect"
                  options={languageCertificate}
                  // getOptionLabel={(option) => option.name}
                  // value={value}
                  onChange={(_, data) => field.onChange(data)}
                  onInputChange={(_, data) => {
                    if (data) field.onChange(data);
                    // field.onChange(data);
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="ประกาศณียบัตรทางภาษา"
                      variant="filled"
                      fullWidth
                      error={!!error}
                      helperText={error ? error.message : null}
                    />
                  )}
                />
              )}
              name="englishLanguageCertificate"
              control={control}
            />
          </FormControl>
        </Grid>

        {/* 
        |
        |
        | ภาษาต่างประเทศ อื่นๆ 
        |
        |
        */}
        {languageSkillFields.map((item, index) => {
          return (
            <>
              <Grid item xs={2} sm={2}>
                <rhf.Controller
                  render={({ field, fieldState: { error } }) => (
                    <TextField
                      variant="filled"
                      label="ภาษา"
                      fullWidth
                      error={!!error}
                      helperText={error ? error.message : null}
                      {...field}
                    />
                  )}
                  name={`othersLanguageSkill[${index}].languageSkill`}
                  control={control}
                />
              </Grid>
              <Grid item xs={2} sm={2}>
                <FormControl
                  // error={rhf.errors.othersLanguageSkill}
                  variant="filled"
                  fullWidth
                >
                  <InputLabel>พูด</InputLabel>
                  <Controller
                    render={({ field: { onChange, value } }) => (
                      <Select onChange={onChange} value={value}>
                        {languageSkill.map((level) => (
                          <MenuItem key={level.value} value={level.value}>
                            {level.label}
                          </MenuItem>
                        ))}
                      </Select>
                    )}
                    control={control}
                    name={`othersLanguageSkill[${index}].speak`}
                  />
                  <FormHelperText
                    error={rhf.errors.othersLanguageSkill?.[index].speak}
                  >
                    {rhf.errors.othersLanguageSkill?.[index].speak
                      ? '(' +
                        rhf.errors.othersLanguageSkill?.[index].speak.message +
                        ')'
                      : ''}
                  </FormHelperText>
                </FormControl>
              </Grid>
              <Grid item xs={2} sm={2}>
                <FormControl
                  // error={rhf.errors.englishLanguageSkillRead}
                  variant="filled"
                  fullWidth
                >
                  <InputLabel>อ่าน</InputLabel>
                  <Controller
                    render={({ field: { onChange, value } }) => (
                      <Select onChange={onChange} value={value}>
                        {languageSkill.map((level) => (
                          <MenuItem key={level.value} value={level.value}>
                            {level.label}
                          </MenuItem>
                        ))}
                      </Select>
                    )}
                    control={control}
                    name={`othersLanguageSkill[${index}].read`}
                  />
                  {/* <FormHelperText error={rhf.errors.englishLanguageSkillRead}>
                    {rhf.errors.englishLanguageSkillRead
                      ? '(' + rhf.errors.englishLanguageSkillRead.message + ')'
                      : ''}
                  </FormHelperText> */}
                </FormControl>
              </Grid>
              <Grid item xs={2} sm={2}>
                <FormControl
                  error={rhf.errors.englishLanguageSkillWrite}
                  variant="filled"
                  fullWidth
                >
                  <InputLabel>เขียน</InputLabel>
                  <Controller
                    render={({ field: { onChange, value } }) => (
                      <Select onChange={onChange} value={value}>
                        {languageSkill.map((level) => (
                          <MenuItem key={level.value} value={level.value}>
                            {level.label}
                          </MenuItem>
                        ))}
                      </Select>
                    )}
                    control={control}
                    name={`othersLanguageSkill[${index}].write`}
                  />
                  {/* <FormHelperText error={rhf.errors.englishLanguageSkillWrite}>
                    {rhf.errors.englishLanguageSkillWrite
                      ? '(' + rhf.errors.englishLanguageSkillWrite.message + ')'
                      : ''}
                  </FormHelperText> */}
                </FormControl>
              </Grid>
              <Grid item xs={2} sm={2}>
                <FormControl
                  // error={rhf.errors.englishLanguageCertificate}
                  variant="filled"
                  fullWidth
                >
                  {/* copy from above */}
                  <rhf.Controller
                    render={({ field, fieldState: { error }, value }) => (
                      <Autocomplete
                        {...field}
                        freeSolo
                        id="othersLanguageSkillSelect"
                        options={languageCertificate}
                        // getOptionLabel={(option) => option.name}
                        // value={value}
                        onChange={(_, data) => field.onChange(data)}
                        onInputChange={(_, data) => {
                          if (data) field.onChange(data);
                          // field.onChange(data);
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="ประกาศณียบัตรทางภาษา"
                            variant="filled"
                            fullWidth
                            error={!!error}
                            helperText={error ? error.message : null}
                          />
                        )}
                      />
                    )}
                    name={`othersLanguageSkill[${index}].certificate`}
                    control={control}
                  />
                </FormControl>
              </Grid>
              <Grid item xs={1} sm={1}>
                <Button
                  variant="outlined"
                  startIcon={<DeleteOutlineIcon />}
                  onClick={() => languageSkillRemove(index)}
                >
                  ลบ
                </Button>
              </Grid>
            </>
          );
        })}
        <Grid item xs={12} sm={12}></Grid>
        <Grid item xs={2} sm={2}>
          <Button
            variant="outlined"
            onClick={() => {
              languageSkillAppend({
                languageSkill: '',
                speak: '',
                read: '',
                write: '',
                certificate: '',
              });
            }}
          >
            + เพิ่มภาษา
          </Button>
        </Grid>
        <Grid item xs={4} sm={4}></Grid>
        <Grid item xs={4} sm={4}></Grid>
        <Grid item xs={4} sm={4}></Grid>
      </Grid>

      {/* 
      |
      |
      | ประสบการณ์การทำงาน
      |
      |
      */}
      <Box p={0} display="flex" sx={{ pb: 0, pt: 7 }}>
        <H3>ประสบการณ์การทำงาน</H3>
      </Box>
      <Divider sx={{ mb: 2 }} />
      <Grid container spacing={2}>
        <Grid item xs={12} sm={12}>
          <Typography sx={{ pb: 0, pt: 0 }} variant="subtitle1" gutterBottom>
            *ประวัติการทำงานกับบริษัทเอกชน หรือราชการอื่นๆรวมทั้งเหตุผลที่ออก
            เช่น เปลี่ยนงานใหม่ ย้ายสถานที่ทำงาน เป็นต้น
          </Typography>
        </Grid>
        <Grid item xs={12} sm={12}>
          <Paper elevation={1}>
            {/* <WorkExperiece /> */}
            <RadioFieldRHFRow
              name="isWorkExperience"
              label="isWorkExperience-label"
              rhf={rhf}
              options={workExperienceOptions}
              error={rhf.errors.isWorkExperience}
              // initial '' ที่ EmploymentPage ด้วย
            />
          </Paper>
        </Grid>
        {/* {hasWorkExperienceRdx} */}

        {hasWorkExperience == 'Y' &&
          workExperienceFields.map((item, index) => {
            return (
              <>
                <Grid
                  item
                  xs={3}
                  sm={3}
                  component={Stack}
                  justifyContent="flex-start"
                  alignItems="flex-end"
                >
                  <Typography
                    sx={{
                      pb: 0,
                      pt: 0,
                      color: 'success.main',
                    }}
                    variant="subtitle1"
                    gutterBottom
                  >
                    {index != 0 && `การทำงานหน่วยงานที่ ${index + 1}`}
                  </Typography>
                </Grid>
                <Grid item xs={7} sm={7}></Grid>

                <Grid item xs={3} sm={3}>
                  <rhf.Controller
                    render={({ field, fieldState: { error } }) => (
                      <TextField
                        variant="filled"
                        label="ชื่อหน่วยงาน"
                        fullWidth
                        error={!!error}
                        helperText={error ? error.message : null}
                        {...field}
                      />
                    )}
                    name={`workExperienceFields[${index}].workName`}
                    control={control}
                  />
                </Grid>
                <Grid item xs={2} sm={2}>
                  <rhf.Controller
                    render={({ field, fieldState: { error } }) => (
                      <TextField
                        variant="filled"
                        label="ตำแหน่ง"
                        fullWidth
                        error={!!error}
                        helperText={error ? error.message : null}
                        {...field}
                      />
                    )}
                    name={`workExperienceFields[${index}].workDuty`}
                    control={control}
                  />
                </Grid>
                <Grid item xs={3} sm={3}>
                  <rhf.Controller
                    render={({ field, fieldState: { error } }) => (
                      <TextField
                        variant="filled"
                        label="อัตราเงินเดือน (บาท)"
                        fullWidth
                        error={!!error}
                        helperText={error ? error.message : null}
                        {...field}
                      />
                    )}
                    name={`workExperienceFields[${index}].workSalary`}
                    control={control}
                  />
                </Grid>
                <Grid item xs={2} sm={2}>
                  <rhf.Controller
                    render={({ field, fieldState: { error } }) => (
                      <TextField
                        variant="filled"
                        label="เป็นระยะเวลา (ปี)"
                        fullWidth
                        type="number"
                        error={!!error}
                        helperText={error ? error.message : null}
                        {...field}
                      />
                    )}
                    name={`workExperienceFields[${index}].workPeriod`}
                    control={control}
                  />
                </Grid>
                {index != 0 && (
                  <Grid item xs={2} sm={2}>
                    <Button
                      variant="outlined"
                      startIcon={<DeleteOutlineIcon />}
                      onClick={() => workExperienceRemove(index)}
                    >
                      ลบ
                    </Button>
                  </Grid>
                )}

                <Grid item xs={12} sm={12}></Grid>
              </>
            );
          })}
        <Grid item xs={3} sm={3}>
          <Button
            variant="outlined"
            onClick={() => {
              hasWorkExperience == 'Y' && workExperienceAppend({});
              // hasWorkExperienceRdx == 'Y' && workExperienceAppend({});
            }}
          >
            + เพิ่มประสบการณ์ทำงาน
          </Button>
        </Grid>

        <Grid item xs={3} sm={3}></Grid>
        <Grid item xs={4} sm={4}></Grid>
        <Grid item xs={4} sm={4}></Grid>
      </Grid>

      {/* 
      |
      |
      | ประวัติการฝึกอบรม/ฝึกงาน
      |
      |
      */}
      <Box p={0} display="flex" sx={{ pb: 0, pt: 7 }}>
        <H3>ประวัติการฝึกอบรม/ฝึกงาน</H3>
      </Box>
      <Divider sx={{ mb: 2 }} />
      <Grid container spacing={2}>
        {trainingHistoryFields.map((item, index) => {
          return (
            <>
              <Grid
                item
                xs={3}
                sm={3}
                component={Stack}
                justifyContent="flex-start"
                alignItems="flex-end"
              >
                <Typography
                  sx={{
                    pb: 0,
                    pt: 0,
                    color: 'success.main',
                  }}
                  variant="subtitle1"
                  gutterBottom
                >
                  {index != 0 && `หน่วยงานที่ ${index + 1}`}
                </Typography>
              </Grid>
              <Grid item xs={9} sm={9}></Grid>

              <Grid item xs={2} sm={2}>
                <LocalizationProvider dateAdapter={AdapterDateFns} locale={th}>
                  <rhf.Controller
                    control={control}
                    name={`trainingHistory[${index}].year`}
                    render={({ field: { onChange, value = null } }) => (
                      <DatePicker
                        views={['year']}
                        label="ปี พ.ศ."
                        // inputFormat="dd/MM/yyyy"
                        value={value}
                        onChange={onChange}
                        renderInput={(params) => (
                          <TextField variant="filled" fullWidth {...params} />
                        )}
                      />
                    )}
                  />
                </LocalizationProvider>
              </Grid>
              <Grid item xs={3} sm={3}>
                <rhf.Controller
                  render={({ field, fieldState: { error } }) => (
                    <TextField
                      variant="filled"
                      label="ชื่อหน่วยงาน"
                      fullWidth
                      error={!!error}
                      helperText={error ? error.message : null}
                      {...field}
                    />
                  )}
                  name={`trainingHistory[${index}].companyName`}
                  control={control}
                />
              </Grid>

              {index != 0 ? (
                <Grid item xs={2} sm={2}>
                  <Button
                    variant="outlined"
                    startIcon={<DeleteOutlineIcon />}
                    onClick={() => trainingHistoryRemove(index)}
                  >
                    ลบ
                  </Button>
                </Grid>
              ) : (
                <Grid item xs={2} sm={2}></Grid>
              )}
              <Grid item xs={5} sm={5}></Grid>

              <Grid item xs={12} sm={12}></Grid>
            </>
          );
        })}
        <Grid item xs={3} sm={3}>
          <Button
            variant="outlined"
            onClick={() => {
              trainingHistoryAppend({});
            }}
          >
            + เพิ่มประวัติการฝึกอบรม/ฝึกงาน
          </Button>
        </Grid>

        <Grid item xs={3} sm={3}></Grid>
        <Grid item xs={4} sm={4}></Grid>
        <Grid item xs={4} sm={4}></Grid>
      </Grid>

      {/* 
      |
      |
      | ความรู้ด้านคอมพิวเตอร์
      |
      |
      */}
      <Box p={0} display="flex" sx={{ pb: 0, pt: 7 }}>
        <H3>ความรู้ด้านคอมพิวเตอร์</H3>
      </Box>
      <Divider sx={{ mb: 2 }} />
      <Grid container spacing={2}>
        <Grid item xs={12} sm={12}>
          <Paper elevation={1}>
            <CheckboxFieldRHFRow
              name="computerSkills"
              label="computerSkills-label"
              rhf={rhf}
              options={computerSkillOptions}
              error={rhf.errors.computerSkills}
              // initial '' ที่ EmploymentPage ด้วย
            />
          </Paper>
        </Grid>
      </Grid>

      {/* 
      |
      |
      | ความรู้ความสามารถพิเศษอื่นๆ (ถ้ามี)
      |
      |
      */}
      <Box p={0} display="flex" sx={{ pb: 0, pt: 7 }}>
        <H3>ความรู้ความสามารถพิเศษอื่นๆ (ถ้ามี)</H3>
      </Box>
      <Divider sx={{ mb: 2 }} />
      <Grid container spacing={2}>
        <Grid item xs={6} sm={6}>
          <OthersSkill rhf={rhf} control={control} />
        </Grid>
        <Grid item xs={6} sm={6} />
      </Grid>

      {/* 
      |
      |
      | สถานะทางทหาร
      |
      |
      */}
      <Box p={0} display="flex" sx={{ pb: 0, pt: 7 }}>
        <H3>สถานะทางทหาร</H3>
      </Box>
      <Divider sx={{ mb: 2 }} />
      <Grid container spacing={2}>
        <Grid item xs={9} sm={9}>
          <Paper elevation={1}>
            <RadioFieldRHFRow
              name="militaryStatus"
              label="militaryStatus-label"
              rhf={rhf}
              options={militaryStatusOptions}
              error={rhf.errors.militaryStatus}
              // initial '' ที่ EmploymentPage ด้วย
            />
            <rhf.Controller
              render={({ field, fieldState: { error } }) => (
                <TextField
                  sx={{ ml: 7, mb: 3, pr: 24 }}
                  variant="filled"
                  label="เหตุผล"
                  fullWidth
                  error={!!error}
                  helperText={error ? error.message : null}
                  {...field}
                />
              )}
              name="militaryStatusReason"
              control={control}
            />
          </Paper>
        </Grid>
        <Grid item xs={3} sm={3}></Grid>
      </Grid>

      {/* 
      |
      |
      | สถานภาพ
      |
      |
      */}
      <Box p={0} display="flex" sx={{ pb: 0, pt: 7 }}>
        <H3>สถานภาพ</H3>
      </Box>
      <Divider sx={{ mb: 2 }} />
      <Grid container spacing={2}>
        {/* <Grid item xs={12} sm={12}>
          <Typography sx={{ pb: 0, pt: 0 }} variant="subtitle1" gutterBottom>
            *ประวัติการทำงานกับบริษัทเอกชน หรือราชการอื่นๆรวมทั้งเหตุผลที่ออก
            เช่น เปลี่ยนงานใหม่ ย้ายสถานที่ทำงาน เป็นต้น
          </Typography>
        </Grid> */}
        <Grid item xs={12} sm={12}>
          <Paper elevation={1}>
            <RadioFieldRHFRow
              name="maritalStatus"
              label="maritalStatus-label"
              rhf={rhf}
              options={maritalStatusOptions}
              error={rhf.errors.maritalStatus}
              // initial '' ที่ EmploymentPage ด้วย
            />
          </Paper>
        </Grid>
        {hasMarried == '' && (
          <>
            <Grid item xs={5} sm={5}>
              <rhf.Controller
                render={({ field, fieldState: { error } }) => (
                  <TextField
                    variant="filled"
                    label="ชื่อ-นามสกุล คู่สมรส"
                    fullWidth
                    error={!!error}
                    helperText={error ? error.message : null}
                    {...field}
                  />
                )}
                name="spouseName"
                control={control}
              />
            </Grid>
            <Grid item xs={2} sm={2}>
              <rhf.Controller
                render={({ field, fieldState: { error } }) => (
                  <TextField
                    variant="filled"
                    label="จำนวนบุตร"
                    fullWidth
                    error={!!error}
                    type="number"
                    helperText={error ? error.message : null}
                    {...field}
                  />
                )}
                name="numberOfChildren"
                control={control}
              />
            </Grid>
            <Grid item xs={5} sm={5}></Grid>
            <Grid item xs={5} sm={5}>
              <rhf.Controller
                render={({ field, fieldState: { error } }) => (
                  <TextField
                    variant="filled"
                    label="สถานที่ทำงานคู่สมรส"
                    fullWidth
                    error={!!error}
                    helperText={error ? error.message : null}
                    {...field}
                  />
                )}
                name="spouseOffice"
                control={control}
              />
            </Grid>
            <Grid item xs={2} sm={2}>
              <rhf.Controller
                render={({ field, fieldState: { error } }) => (
                  <TextField
                    variant="filled"
                    label="โทรศัพท์"
                    fullWidth
                    error={!!error}
                    helperText={error ? error.message : null}
                    {...field}
                  />
                )}
                name="spousePhone"
                control={control}
              />
            </Grid>
          </>
        )}
      </Grid>

      {/* {hasWorkExperience == 'Y' && (
          <>
            <Grid item xs={3} sm={3}>
              <rhf.Controller
                render={({ field, fieldState: { error } }) => (
                  <TextField
                    variant="filled"
                    label="ชื่อหน่วยงาน"
                    fullWidth
                    error={!!error}
                    helperText={error ? error.message : null}
                    {...field}
                  />
                )}
                name={`xxx`}
                control={control}
              />
            </Grid>
          </>
        )} */}

      {/* 
      |
      |
      | คำรับรองผู้สมัคร
      |
      |
      */}
      <Box p={0} display="flex" sx={{ pb: 0, pt: 7 }}>
        <H3>คำรับรองผู้สมัคร</H3>
      </Box>
      <Divider sx={{ mb: 2 }} />
      <Grid container spacing={2}>
        <Grid item xs={1} sm={1} />
        <Grid item xs={9} sm={9}>
          <Typography sx={{ pb: 0, pt: 0 }} variant="subtitle1" gutterBottom>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            ข้าพเจ้าขอให้คำรับรองว่าเป็นผู้มีคุณสมบัติตรงตามประกาศ กฟผ.
            และไม่มีลักษณะต้องห้ามดังกล่าวข้างต้น
            รวมทั้งข้อความและเอกสารหลักฐานตามที่ระบุไว้ในใบสมัครนี้เป็นความจริง
            ถูกต้อง สมบูรณ์ทุกประการ ข้าพเจ้ายินยอมให้ กฟผ.
            ตรวจสอบความถูกต้องของข้อมูลและเอกสารหลักฐาน รวมถึงยินยอมให้นายจ้าง
            สถาบัน หรือบุคคลใดๆ ให้รายละเอียดดังกล่าวแก่ กฟผ. ทั้งนี้ กฟผ.
            สงวนสิทธิ์ในการตรวจสอบความถูกต้องของข้อมูลและเอกสารต่างๆ
            ย้อนหลังได้ทุกกรณี และหาก กฟผ. ตรวจสอบภายหลังแล้วพบว่า
            ข้าพเจ้าเป็นผู้ที่ไม่มีคุณสมบัติตามที่ กฟผ. กำหนด หรือข้อมูล
            เอกสารหลักฐานประกอบการจ้างไม่เป็นความจริง ไม่ถูกต้อง ไม่สมบูรณ์
            หรือใช้เอกสารปลอม จะถือว่าข้าพเจ้าเป็นผู้ขาดคุณสมบัติ และ กฟผ.
            มีสิทธิ์เลิกจ้าง รวมทั้งดำเนินคดีตามกฎหมาย
            โดยข้าพเจ้าไม่สามารถเรียกร้องสิทธิ์หรือค่าเสียหายใดๆ จาก กฟผ. ได้
          </Typography>
        </Grid>
        <Grid item xs={2} sm={2} />

        <Grid item xs={1} sm={1} />
        <Grid item xs={8} sm={8}>
          {/* <Paper elevation={1} sx={{ p: 4 }}> */}
          <CheckboxFieldRHFRow
            name="acceptAgreement"
            label="acceptAgreement-label"
            rhf={rhf}
            options={acceptAgreementOptions}
            error={rhf.errors.acceptAgreement}
            // initial '' ที่ EmploymentPage ด้วย
          />
          {/* </Paper> */}
        </Grid>
        <Grid item xs={3} sm={3} />
      </Grid>

      {/* 
      |
      |
      | เอกสารแนบ
      |
      |
      */}
      <Box p={0} display="flex" sx={{ pb: 0, pt: 7 }}>
        <H3>เอกสารแนบประกอบการทำหลักฐาน</H3>
      </Box>
      <Divider sx={{ mb: 2 }} />
      <Grid container spacing={2}>
        <Grid item xs={12} sm={12}>
          <Typography sx={{ pb: 0, pt: 0 }} variant="subtitle1" gutterBottom>
            หมายเหตุ: ต้องเป็นไฟล์นามสกุล .pdf เท่านั้น โดยแต่ละไฟล์ขนาดไม่เกิน
            1 เมกะไบต์ (MB)
          </Typography>
        </Grid>
        {/* <Grid item xs={12} sm={12}> */}
        <Grid item xs={2} sm={2}>
          <Typography sx={{ pb: 0, pt: 0 }} variant="subtitle1" gutterBottom>
            สำเนาคุณวุฒิ
          </Typography>
        </Grid>
        <Grid item xs={4} sm={4}>
          {/* {JSON.stringify(formikProps.file1Name)} */}
          {/* <FileUpload /> */}
          <FileUpload
            {...props}
            rhf={rhf}
            control={control}
            // msg1={` สำเนาคุณวุฒิ`}
            formikName={`file4Name`}
            // rdxFileData={file1Data}
            // rdxSetFileData={setFile1Data}
          />
        </Grid>
        <Grid item xs={2} sm={2}>
          <Typography sx={{ pb: 0, pt: 0 }} variant="subtitle1" gutterBottom>
            ใบปริญญาบัตร
          </Typography>
        </Grid>
        <Grid item xs={4} sm={4}>
          {/* {JSON.stringify(formikProps.file1Name)} */}
          {/* <FileUpload /> */}
          <FileUpload
            {...props}
            rhf={rhf}
            control={control}
            // msg1={` ใบปริญญาบัตร`}
            formikName={`file5Name`}
            // rdxFileData={file1Data}
            // rdxSetFileData={setFile1Data}
          />
        </Grid>
        <Grid item xs={2} sm={2}>
          <Typography sx={{ pb: 0, pt: 0 }} variant="subtitle1" gutterBottom>
            สำเนาทะเบียนบ้านตนเอง
          </Typography>
        </Grid>
        <Grid item xs={4} sm={4}>
          {/* {JSON.stringify(formikProps.file1Name)} */}
          {/* <FileUpload /> */}
          <FileUpload
            {...props}
            rhf={rhf}
            control={control}
            // msg1={` สำเนาทะเบียนบ้านตนเอง`}
            formikName={`file6Name`}
            // rdxFileData={file1Data}
            // rdxSetFileData={setFile1Data}
          />
        </Grid>
        <Grid item xs={2} sm={2}>
          <Typography sx={{ pb: 0, pt: 0 }} variant="subtitle1" gutterBottom>
            สำเนาบัตรประชาชนตนเอง
          </Typography>
        </Grid>
        <Grid item xs={4} sm={4}>
          {/* {JSON.stringify(formikProps.file1Name)} */}
          {/* <FileUpload /> */}
          <FileUpload
            {...props}
            rhf={rhf}
            control={control}
            // msg1={` สำเนาบัตรประชาชนตนเอง`}
            formikName={`file7Name`}
            // rdxFileData={file1Data}
            // rdxSetFileData={setFile1Data}
          />
        </Grid>
        <Grid item xs={2} sm={2}>
          <Typography sx={{ pb: 0, pt: 0 }} variant="subtitle1" gutterBottom>
            สำเนาทะเบียนบ้านบิดา
          </Typography>
        </Grid>
        <Grid item xs={4} sm={4}>
          {/* {JSON.stringify(formikProps.file1Name)} */}
          {/* <FileUpload /> */}
          <FileUpload
            {...props}
            rhf={rhf}
            control={control}
            // msg1={` สำเนาทะเบียนบ้านบิดา`}
            formikName={`file8Name`}
            // rdxFileData={file1Data}
            // rdxSetFileData={setFile1Data}
          />
        </Grid>
        <Grid item xs={2} sm={2}>
          <Typography sx={{ pb: 0, pt: 0 }} variant="subtitle1" gutterBottom>
            สำเนาบัตรประชาชนบิดา
          </Typography>
        </Grid>
        <Grid item xs={4} sm={4}>
          {/* {JSON.stringify(formikProps.file1Name)} */}
          {/* <FileUpload /> */}
          <FileUpload
            {...props}
            rhf={rhf}
            control={control}
            // msg1={` สำเนาบัตรประชาชนบิดา`}
            formikName={`file9Name`}
            // rdxFileData={file1Data}
            // rdxSetFileData={setFile1Data}
          />
        </Grid>

        <Grid item xs={2} sm={2}>
          <Typography sx={{ pb: 0, pt: 0 }} variant="subtitle1" gutterBottom>
            สำเนาทะเบียนบ้านมารดา
          </Typography>
        </Grid>
        <Grid item xs={4} sm={4}>
          {/* {JSON.stringify(formikProps.file1Name)} */}
          {/* <FileUpload /> */}
          <FileUpload
            {...props}
            rhf={rhf}
            control={control}
            // msg1={` สำเนาทะเบียนบ้านมารดา`}
            formikName={`file10Name`}
            // rdxFileData={file1Data}
            // rdxSetFileData={setFile1Data}
          />
        </Grid>
        <Grid item xs={2} sm={2}>
          <Typography sx={{ pb: 0, pt: 0 }} variant="subtitle1" gutterBottom>
            สำเนาบัตรประชาชนมารดา
          </Typography>
        </Grid>
        <Grid item xs={4} sm={4}>
          {/* {JSON.stringify(formikProps.file1Name)} */}
          {/* <FileUpload /> */}
          <FileUpload
            {...props}
            rhf={rhf}
            control={control}
            // msg1={` สำเนาบัตรประชาชนมารดา`}
            formikName={`file11Name`}
            // rdxFileData={file1Data}
            // rdxSetFileData={setFile1Data}
          />
        </Grid>

        <Grid item xs={2} sm={2}>
          <Typography sx={{ pb: 0, pt: 0 }} variant="subtitle1" gutterBottom>
            สำเนาสด.8/สด.43
          </Typography>
        </Grid>
        <Grid item xs={4} sm={4}>
          {/* {JSON.stringify(formikProps.file1Name)} */}
          {/* <FileUpload /> */}
          <FileUpload
            {...props}
            rhf={rhf}
            control={control}
            // msg1={` สำเนาสด.8/สด.43`}
            formikName={`file12Name`}
            // rdxFileData={file1Data}
            // rdxSetFileData={setFile1Data}
          />
        </Grid>
        <Grid item xs={2} sm={2}>
          <Typography sx={{ pb: 0, pt: 0 }} variant="subtitle1" gutterBottom>
            สำเนาใบเปลี่ยนชื่อ/นามสกุล ตนเอง
          </Typography>
        </Grid>
        <Grid item xs={4} sm={4}>
          {/* {JSON.stringify(formikProps.file1Name)} */}
          {/* <FileUpload /> */}
          <FileUpload
            {...props}
            rhf={rhf}
            control={control}
            // msg1={` สำเนาใบเปลี่ยนชื่อ/นามสกุล ตนเอง`}
            formikName={`file13Name`}
            // rdxFileData={file1Data}
            // rdxSetFileData={setFile1Data}
          />
        </Grid>

        <Grid item xs={2} sm={2}>
          <Typography sx={{ pb: 0, pt: 0 }} variant="subtitle1" gutterBottom>
            ทะเบียนบ้านที่มีชื่อคู่สมรส บุตร
          </Typography>
        </Grid>
        <Grid item xs={4} sm={4}>
          {/* {JSON.stringify(formikProps.file1Name)} */}
          {/* <FileUpload /> */}
          <FileUpload
            {...props}
            rhf={rhf}
            control={control}
            // msg1={` ทะเบียนบ้านที่มีชื่อคู่สมรส บุตร`}
            formikName={`file14Name`}
            // rdxFileData={file1Data}
            // rdxSetFileData={setFile1Data}
          />
        </Grid>
        <Grid item xs={2} sm={2}>
          <Typography sx={{ pb: 0, pt: 0 }} variant="subtitle1" gutterBottom>
            สำเนาใบสำคัญทะเบียนสมรส
          </Typography>
        </Grid>
        <Grid item xs={4} sm={4}>
          {/* {JSON.stringify(formikProps.file1Name)} */}
          {/* <FileUpload /> */}
          <FileUpload
            {...props}
            rhf={rhf}
            control={control}
            // msg1={` สำเนาใบสำคัญทะเบียนสมรส`}
            formikName={`file15Name`}
            // rdxFileData={file1Data}
            // rdxSetFileData={setFile1Data}
          />
        </Grid>

        <Grid item xs={2} sm={2}>
          <Typography sx={{ pb: 0, pt: 0 }} variant="subtitle1" gutterBottom>
            สำเนาสูติบัตรบุตร
          </Typography>
        </Grid>
        <Grid item xs={4} sm={4}>
          {/* {JSON.stringify(formikProps.file1Name)} */}
          {/* <FileUpload /> */}
          <FileUpload
            {...props}
            rhf={rhf}
            control={control}
            // msg1={` สำเนาสูติบัตรบุตร`}
            formikName={`file16Name`}
            // rdxFileData={file1Data}
            // rdxSetFileData={setFile1Data}
          />
        </Grid>
        <Grid item xs={2} sm={2}>
          <Typography sx={{ pb: 0, pt: 0 }} variant="subtitle1" gutterBottom>
            สำเนารับรองการผ่านงาน และใบลาออก
          </Typography>
        </Grid>
        <Grid item xs={4} sm={4}>
          {/* {JSON.stringify(formikProps.file1Name)} */}
          {/* <FileUpload /> */}
          <FileUpload
            {...props}
            rhf={rhf}
            control={control}
            // msg1={` สำเนารับรองการผ่านงาน และใบลาออก`}
            formikName={`file17Name`}
            // rdxFileData={file1Data}
            // rdxSetFileData={setFile1Data}
          />
        </Grid>
        <Grid item xs={8} sm={8}>
          <Typography sx={{ pb: 0, pt: 0 }} variant="subtitle1" gutterBottom>
            สำเนาเอกสารคุณสมบัติเฉพาะตำแหน่งงาน เช่น ใบกว. เนติบัณฑิต
            วุฒิบัตรผู้สอบบัญชี CIA CISA เป็นต้น
          </Typography>
        </Grid>
        <Grid item xs={4} sm={4}>
          {/* {JSON.stringify(formikProps.file1Name)} */}
          {/* <FileUpload /> */}
          <FileUpload
            {...props}
            rhf={rhf}
            control={control}
            // msg1={` สำเนาเอกสารคุณสมบัติเฉพาะตำแหน่งงาน`}
            formikName={`file18Name`}
            // rdxFileData={file1Data}
            // rdxSetFileData={setFile1Data}
          />
        </Grid>
        {/* <Grid item xs={1} sm={1}></Grid> */}
        {/* </Paper> */}
        {/* </Grid> */}
      </Grid>

      {/* ทดสอบ redux */}
      {/* {file1Data?.name} */}
      {/* {cnt}
      <Button
        variant="outlined"
        color="primary"
        onClick={() => dispatch(increment())}
      >
        Primary
      </Button> */}
    </React.Fragment>
  );
}
